<template>
  <div class="page_salary page_addCalcSalary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic" v-if="active == 2">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="员工姓名" size="small">
              <el-input v-model="listQuery.EmployeeName" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" size="small">
              <el-input v-model="listQuery.CardId" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" size="small">
              <el-input v-model="listQuery.BankAccount" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
          </el-form>
          <!-- <div class="screenInput">
          <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
            <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
          </el-tooltip>
        </div> -->
        </div>
      </div>
      <div class="top-right" v-if="active == 2">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/calcSalary' }">算薪</el-breadcrumb-item>
          <el-breadcrumb-item>新增算薪</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="salaryForm">
          <div class="steps">
            <el-steps :active="active" finish-status="success" align-center>
              <el-step title="获取初始数据"></el-step>
              <el-step title="数据校验"></el-step>
              <el-step title="完成算薪"></el-step>
            </el-steps>
          </div>
          <el-form :model="formData" v-if="active == 0" :inline="true" ref="salaryForm" :rules="rules1" label-width="130px" style="margin-top: 20px;width:1000px">
            <div>
              <el-form-item label="发放类型" prop="ApplySalary.PayType">
                <div class="PayTypeCheck">
                  <!-- <el-radio-group v-model="formData.ApplySalary.PayType" @change="changeWay">
                  <el-radio label="正常发薪" style="margin-right:10px">正常发薪</el-radio>
                  <el-checkbox v-model="PayInjury" v-if="formData.ApplySalary.PayType=='正常发薪'">属工伤工资</el-checkbox>
                  <el-radio label="预支工资">预支工资</el-radio>
                </el-radio-group> -->
                  <el-select v-model="formData.ApplySalary.PayType" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changePayType">
                    <el-option value="工资"></el-option>
                    <el-option value="工伤工资"></el-option>
                    <!-- <el-option value="预支工资"></el-option> -->
                    <el-option value="其他"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="个税申报类型" prop="ApplySalary.IncomeTaxType">
                <el-select v-model="formData.ApplySalary.IncomeTaxType" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeIncomeTaxType" :disabled="!formData.ApplySalary.PayType || formData.ApplySalary.PayType == '其他'">
                  <el-option value="正常工资薪金" v-if="formData.ApplySalary.PayType != '其他'"></el-option>
                  <el-option value="劳务报酬" v-if="formData.ApplySalary.PayType != '其他'"></el-option>
                  <el-option value="全年一次性奖金（一次扣税）" v-if="formData.ApplySalary.PayType == '工资'"></el-option>
                  <el-option value="全年多次性奖金（多次发放）" v-if="formData.ApplySalary.PayType == '工资'"></el-option>
                  <el-option value="解除劳动合同一次性补偿" v-if="formData.ApplySalary.PayType == '工资'"></el-option>
                  <el-option value="保险营销员佣金收入" v-if="formData.ApplySalary.PayType == '工资'"></el-option>
                  <!-- <el-option value="个税差额补发" v-if="formData.ApplySalary.PayType=='工资' || formData.ApplySalary.PayType=='工伤工资'"></el-option> -->
                  <el-option value="不算税" v-if="formData.ApplySalary.PayType == '其他'"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item v-if="formData.ApplySalary.IncomeTaxType == '全年一次性奖金'">
              <div style="width:300px;padding-left: 10px;">
                <el-checkbox v-model="AnnualOneTimeBonus">本年度还有一次性奖金发放</el-checkbox>
              </div>
            </el-form-item> -->
            </div>
            <el-form-item label="共发放" prop="ApplySalary.TaxTypeRemark" v-if="formData.ApplySalary.IncomeTaxType == '全年多次性奖金（多次发放）'">
              <div class="flex" style="width:300px">
                <div v-if="formData.ApplySalary.IncomeTaxType == '全年多次性奖金（多次发放）'">
                  <el-input v-model="not1" type="number" size="small" style="width:100px"></el-input>次
                  报税月份<el-input v-model="not2" type="number" size="small" style="width:100px"></el-input>月
                </div>
                <!-- <div v-if="formData.ApplySalary.IncomeTaxType=='不算税'">
                其他不算税内容为<el-input v-model="not" size="small" style="width:200px"></el-input>
              </div> -->
              </div>
            </el-form-item>
            <!-- <el-form-item label="其他不算税内容为" prop="ApplySalary.TaxTypeRemark" v-if="formData.ApplySalary.IncomeTaxType=='不算税'" label-width="135px">
            <el-input v-model="formData.ApplySalary.TaxTypeRemark" size="small" style="width:275px"></el-input>
          </el-form-item> -->
            <el-form-item label="发薪项目" prop="ApplySalary.ProjectName">
              <el-select v-model="formData.ApplySalary.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable @change="changePro">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属月" prop="ApplySalary.AttrMonth">
              <el-date-picker v-model="formData.ApplySalary.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="个税申报月" prop="ApplySalary.IncomeTaxMonth">
              <el-date-picker v-model="formData.ApplySalary.IncomeTaxMonth" @input="changeIncomeTaxMonth" type="month" :picker-options="pickerOptions" value-format="yyyy-MM" size="small" style="width: 300px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发薪日" prop="ApplySalary.ApplicationDate" v-if="formData.ApplySalary.PayType != '预支工资'">
              <el-select v-model="formData.ApplySalary.ApplicationDate" placeholder="" size="small" style="width: 300px;" filterable>
                <el-option v-for="(item, index) in 31" :key="index" :value="item + '日'"></el-option>
              </el-select>
            </el-form-item>

            <!-- 正常发薪 -->
            <div v-if="formData.ApplySalary.PayType != '预支工资'">

              <div class="tips">备注:当月发放2个月及以上工资，需确认'个税申报月'</div>
              <div class="PersonalTaxIsBorne">
                <el-form-item label="商务合同主体" prop="ApplySalary.Subject">
                  <el-select v-model="formData.ApplySalary.Subject" placeholder="" size="small" style="width: 300px;" filterable>
                    <el-option v-for="(item, index) in SubjectList" :key="index" :value="item.StrSignsubjectName"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="个税计算方式" prop="ApplySalary.PersonalIncomeTaxDataSource">
                  <el-select v-model="formData.ApplySalary.PersonalIncomeTaxDataSource" placeholder="" size="small" style="width: 180px;" :disabled="formData.ApplySalary.PayType == '其他'" clearable filterable>
                    <el-option value="税局计算" v-if="formData.ApplySalary.PayType != '其他'"></el-option>
                    <el-option value="按导入数据"></el-option>
                    <!-- <el-option value="系统计算"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <div style="padding-left: 10px;">
                    <el-checkbox v-model="PersonalTaxIsBorne">个税由个人承担</el-checkbox>
                  </div>
                </el-form-item>
              </div>
              <div class="tips">备注:开票/到款公司</div>

              <el-form-item label="发放途径" prop="ApplySalary.PayrollChannel">
                <el-select v-model="formData.ApplySalary.PayrollChannel" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeChannel" :disabled="!formData.ApplySalary.PersonalIncomeTaxDataSource || !formData.ApplySalary.ProjectId" v-if="supObjList.length==0">
                  <el-option value="银行" v-if="formData.ApplySalary.PayType != '其他'"></el-option>
                  <el-option value="灵活用工" :disabled="formData.ApplySalary.PersonalIncomeTaxDataSource == '税局计算'"></el-option>

                  <!-- <el-option value="安心云" :disabled="formData.ApplySalary.PersonalIncomeTaxDataSource == '税局计算'"></el-option> -->
                  <el-option value="现金"></el-option>
                  <el-option value="报销款（不报税）" v-if="formData.ApplySalary.PayType == '其他'"></el-option>
                  <el-option value="二类卡补发（不报税）" v-if="formData.ApplySalary.PayType == '其他'"></el-option>
                  <el-option value="退个税（不报税）" v-if="formData.ApplySalary.PayType == '其他'"></el-option>
                  <el-option value="预支工资（不报税）" v-if="formData.ApplySalary.PayType == '其他'"></el-option>
                  <el-option value="其他（不报税）" v-if="formData.ApplySalary.PayType == '其他'"></el-option>
                </el-select>
                <el-select v-model="formData.ApplySalary.PayrollChannel" placeholder="" size="small" style="width: 300px;" clearable filterable :disabled="!formData.ApplySalary.PersonalIncomeTaxDataSource" v-if="supObjList.length>0">
                  <el-option value="现金"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="落地公司" prop="ApplySalary.LandingCompany" v-if="formData.ApplySalary.PayrollChannel == '灵活用工'">
                <el-select v-model="formData.ApplySalary.LandingCompany" placeholder="" size="small" style="width: 300px;" clearable filterable>
                  <el-option v-for="(item, index) in sendWayList" :key="index" :label="item.CompanyNameOptional" :value="item.CompanyNameOptional"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="初始数据来源" prop="ApplySalary.InitialDataSource">
                <el-select v-model="formData.ApplySalary.InitialDataSource" placeholder="" size="small" style="width: 300px;" clearable filterable>
                  <el-option value="导入表"></el-option>
                  <!-- <el-option value="复制上期数据"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="指定发放银行账户">
                <div class="bankset flex aic">
                  <el-radio-group v-model="formData.ApplySalary.SpecifyBankAccount" @input="changeSpecifyBankAccount">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                  <el-select v-model="formData.ApplySalary.BankAccount" placeholder="请选择银行账户" size="small" clearable filterable style="width: 400px;margin:0 20px;" :disabled="formData.ApplySalary.SpecifyBankAccount != true">
                    <el-option v-for="(item, index) in bankList" :key="index" :label="item.AccountName + '——' + item.BankName + '——' + item.Account" :value="item.AccountName + '——' + item.BankName + '——' + item.Account"></el-option>
                  </el-select>
                  <i class="el-icon-question" style="font-size: 12px;color: #4B87E0;">提示：</i>
                  <span style="color: #909399; font-size: 12px;">一般适用于共管账户发放</span>
                </div>
              </el-form-item>

              <el-form-item label="申请备注">
                <el-input type="textarea" v-model="formData.ApplySalary.ApplyforRemark" :autosize="{ minRows: 2 }" size="small" style="width: 300px;"></el-input>
              </el-form-item>
              <el-form-item label="发薪摘要" prop="ApplySalary.PayrollSummary">
                <el-input type="textarea" v-model="formData.ApplySalary.PayrollSummary" :autosize="{ minRows: 2 }" size="small" style="width: 300px;" maxlength="20" show-word-limit></el-input>
              </el-form-item>
              <div class="tips zybz">备注:银行发给员工的发薪短信中会显示的字段，不能填 “工资”、“薪酬” 这两个字眼，请用“报酬”替代。</div>
              <div class="importBox" v-if="formData.ApplySalary.InitialDataSource == '导入表' && formData.ApplySalary.ProjectName">
                <div>
                  <el-form-item label="选择导入模板" prop="ApplySalary.ImportTempId">
                    <div class="flex">
                      <el-select v-model="tempData" placeholder="" size="small" value-key="TempName" style="width: 300px;" clearable filterable @change="changeTemp">
                        <el-option v-for="(item, index) in tempList" :key="index" :value="item" :label="item.TempName"></el-option>
                      </el-select>
                      <div class="tempBtnBox" style="width:280px">
                        <el-button type="text" @click="downTemp" v-if="tempData.TempName">下载模板</el-button>
                        <el-button type="text" @click="editTemp" v-if="tempData.TempName && tempData.TempName != '系统导入薪资明细默认模板'">编辑模板</el-button>
                        <el-button type="text" @click="delTemp" v-if="tempData.TempName && tempData.TempName != '系统导入薪资明细默认模板'">删除模板</el-button>
                        <el-button type="text" @click="setNewTemp" v-if="formData.ApplySalary.ProjectName">新建模板</el-button>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item label="导入薪资表" prop="ApplySalary.PayScaleRUL">
                  <!-- <div class="file-box">
                    <input readonly style="width: 238px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
                    <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
                    <label for="fileInput" class="file-btn cp">导入</label>
                  </div> -->
                  <div style="width:300px">
                    <el-upload class="upload-demo" action="" :on-remove="handleRemove1" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed1" :on-change="handleUploadPSR" accept=".xlsx,.xls" :file-list="fileListPSR">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </div>
                </el-form-item>

                <el-form-item label="上传客户原表" prop="ApplySalary.CustomerOriginalTableRul">
                  <!-- <div class="file-box">
                  <input readonly style="width: 238px;height:32px;margin-top: 4px;" id="applyLicense2" type="text" v-model="ExcelSrc2.fileName" autocomplete="off">
                  <input id="fileInput2" type="file" name="file" accept=".xlsx,.xls" @change="importf2(this)" ref="upload2">
                  <label for="fileInput2" class="file-btn cp">上传</label>
                </div> -->
                  <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="9" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUploadCOT" :file-list="fileList">
                    <el-button size="small" type="primary">点击上传（可多个）</el-button>
                  </el-upload>
                </el-form-item>
              </div>
              <div class="salaryInfo flex importBox lastBox" v-if="batchData.length > 0">
                <div class="salaryInfoTitle lastInfo">最近发薪信息：</div>
                <div class="salaryInfoItem">发薪金额 ：{{ batchData[0].TotalResponse }}</div>
                <div class="salaryInfoItem">归属月：{{ batchData[0].AttrMonth }}</div>
                <div class="salaryInfoItem">申请日期：{{ batchData[0].CreateTime.split('T')[0] }}</div>
                <!-- <div class="salaryInfoItem">发放日期：</div> -->
              </div>

              <!-- <div>
              <el-button type="text" @click="getPaymentInfo">关联到款信息>></el-button>
            </div> -->
              <div v-if="showPaymentInfo" class="showPaymentInfo">
                <div class="selectCustomPayment">选择对应客户到款：</div>
                <el-table :data="PaymentData" class="doc_table" @selection-change="handleSelectionChange" style="width:100%;margin-bottom: 20px;">
                  <el-table-column type="selection" width="60" fixed="left">
                  </el-table-column>
                  <el-table-column prop="s2.PaymentNum" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
                  </el-table-column>
                  <el-table-column prop="s2.TransactionSerialNumber" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="s2.BankTransactionDate" label="到款时间" width="155" align="center">
                    <template slot-scope={row}>
                      {{ row.s2.BankTransactionDate ? row.s2.BankTransactionDate.replace('T', ' ')
                        : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="s2.OppositeOpeningBank" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="s2.AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="s2.IncurredAmount" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="r.AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="r.EmainingAvailableCredit" label="可用金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="r.ProjectName" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="s2.OppositeName" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="r.CreateTime" label="认领时间" width="155" align="center">
                    <template slot-scope={row}>
                      {{ row.r.CreateTime ? row.r.CreateTime.replace('T', ' ') : '' }}
                    </template>
                  </el-table-column>
                </el-table>

                <el-form-item>
                  <el-checkbox v-model="NeedApplyDeposit">需要申请垫支</el-checkbox>
                  <el-input v-model="formData.ApplySalary.ApplyDeposit" :disabled="!NeedApplyDeposit" placeholder="请输入垫资金额" style="width:200px;margin-left: 20px;" size="small"></el-input>
                </el-form-item>
              </div>
            </div>

            <div v-if="formData.ApplySalary.PayType == '预支工资'">
              <el-form-item label="商务合同主体" prop="Subject">
                <el-select v-model="formData.ApplySalary.Subject" placeholder="" size="small" style="width: 300px;" clearable filterable>
                  <el-option v-for="(item, index) in SubjectList" :key="index" :value="item.StrSignsubjectName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="个税计算方式" prop="ApplySalary.PersonalIncomeTaxDataSource">
                <el-select v-model="formData.ApplySalary.PersonalIncomeTaxDataSource" placeholder="" size="small" style="width: 180px;" clearable filterable>
                  <el-option value="税局计算"></el-option>
                  <el-option value="按导入数据"></el-option>
                </el-select>
              </el-form-item>
              <div class="tips">备注:开票/到款公司</div>
              <el-form-item label="发放途径" prop="ApplySalary.PayrollChannel">
                <el-select v-model="formData.ApplySalary.PayrollChannel" placeholder="" size="small" style="width: 300px;" clearable filterable>
                  <el-option value="银行" v-if="supObjList.length==0"></el-option>
                  <el-option value="灵活用工" v-if="supObjList.length==0"></el-option>
                  <!-- <el-option value="安心云"></el-option> -->
                  <el-option value="现金"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="落地公司" prop="LandingCompany" v-if="formData.ApplySalary.PayrollChannel == '灵活用工'">
                <el-select v-model="formData.ApplySalary.LandingCompany" placeholder="" size="small" style="width: 300px;" clearable filterable>
                  <el-option v-for="(item, index) in sendWayList" :key="index" :label="item.CompanyNameOptional" :value="item.Id"></el-option>
                </el-select>
              </el-form-item>

              <div style="margin-bottom: 20px;">
                <el-table :data="formData.userList" class="doc_table" style="width:1161px;">
                  <el-table-column prop="EmployeeName" label="员工姓名" width="100" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.EmployeeName" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="CardId" label="身份证号码" width="180" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.CardId" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="BankAccount" label="银行帐号" width="120" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.BankAccount" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="DepositBank" label="开户行" width="120" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.DepositBank" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="Cardholder" label="持卡人" width="100" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.Cardholder" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="PhoneNum" label="电话" width="120" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.PhoneNum" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="AdvanceWages" label="预支金额" width="120" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.AdvanceWages" size="small" @blur="getTruePay(row)"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="IndividualIncomeTax" label="应扣个税" width="100" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.IndividualIncomeTax" size="small" @blur="getTruePay(row)"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="IssuedThisMonth" label="实发金额" width="100" align="center">
                    <template slot-scope={row}>
                      <el-input v-model="row.IssuedThisMonth" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="IssuedThisMonth" label="发薪公司" width="200" align="center">
                    <template slot-scope={row}>
                      <el-select v-model="row.PayrollCompany" placeholder="" value-key="Projectid" size="small" clearable filterable>
                        <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" align="center">
                    <template slot-scope={row,$index}>
                      <div class="injuryTabBtn">
                        <el-button type="text" @click="delLine($index)" v-if="formData.userList.length > 1">删除行</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button type="text" @click="addLine" style="margin-left:50px" v-if="!formData.ApplySalary.PayScaleRUL">添加行</el-button>
              </div>

              <el-form-item label="导入名单">
                <div class="file-box">
                  <input readonly style="width: 238px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
                  <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
                  <label for="fileInput" class="file-btn cp">导入</label>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button type="text" @click="downAdvTemp()">下载模板</el-button>
              </el-form-item>

              <div>
                <el-form-item label="申请备注">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" v-model="formData.ApplySalary.ApplicationRemarks" size="small" style="width:600px"></el-input>
                </el-form-item>
              </div>
            </div>

          </el-form>

          <!-- 校验 -->
          <div class="abnormalWarning" v-if="active == 1">
            <div>
              <!-- <div class="abnormalTitle"><i class="el-icon-warning"></i> 数据错误提醒：</div>
            <div class="abnItem">1、第XX行，XXXXXXX <br>
              2、第XX行，XXXXXXXXXXXXX <br>
              3、第XXXX行，XXXXXXXXXXX</div>
            <div class="abnItem">
              <el-button type="text" size="small">更多</el-button>
              <el-button type="text" size="small">下载</el-button>
            </div>

            <div class="abnormalTitle"><i class="el-icon-warning"></i> 系统风控提醒：</div>
            <div class="abnItem">
              本批发薪有<span class="errNum">11</span>人有重复发薪数据，请修改后再提交。
              <el-table :data="gridData" style="width:301px">
                <el-table-column width="90" property="name" align="center" label="员工姓名"></el-table-column>
                <el-table-column width="120" property="name" align="center" label="身份证号码"></el-table-column>
                <el-table-column width="90" property="name" align="center" label="金额"></el-table-column>
              </el-table>
            </div>

            <div class="abnormalTitle"><i class="el-icon-warning"></i> 系统风控提醒：</div>
            <div class="abnItem">本批发薪数据中发薪公司 <span class="errNum">XX、YY</span>未开通发薪功能,请检查修改后再提交。</div> -->

              <div v-if="ret1List.length > 0">
                <div class="abnormalTitle"><i class="el-icon-warning"></i> 异常提醒：</div>
                <div class="abnItem flex aic">
                  <!-- 共导入 100 条数据， -->
                  有 <span class="errNum">{{ ret1List.length }}</span> 人身份信息与花名册/商保参保信息比对不一致
                  <el-popover placement="top" width="1200" trigger="click">
                    <el-table :data="ret1List" max-height="500px">
                      <el-table-column width="100" property="projectName" align="center" label="项目名称" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="100" property="EmpName" align="center" label="员工姓名"></el-table-column>
                      <el-table-column width="160" property="StrIdCard" align="center" label="身份证号码"></el-table-column>
                      <el-table-column width="100" property="PhoneNum" align="center" label="手机号"></el-table-column>
                      <el-table-column width="100" property="StrWorkState" align="center" label="在/离职状态" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="170" property="CheckName" align="center" label="身份证信息与花名册对比" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="180" property="InsuranceNameCheck" align="center" label="身份信息与商保保信息比对" :show-overflow-tooltip="true">
                        <template slot-scope={row}>
                          {{ row.InsuranceNameCheck ? row.InsuranceNameCheck : '无商保信息' }}
                        </template>
                      </el-table-column>
                      <el-table-column width="170" property="CheckBankCard" align="center" label="姓名/银行卡与花名册比对" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="150" property="CheckPhoneNum" align="center" label="手机号与花名册比对" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="170" property="CheckEmploymentDay" align="center" label="入职日期与花名册比对" :show-overflow-tooltip="true"></el-table-column>
                    </el-table>
                    <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
                  </el-popover>
                  <!-- <el-button type="text" size="small">下载</el-button> -->
                </div>
              </div>


              <div>
                <div class="abnItem flex aic">
                  <!-- 共导入 100 条数据， -->
                  有 <span class="errNum">{{ ret2List.length }}</span> 人无签约信息
                  <el-popover placement="top" width="620" trigger="click">
                    <el-table :data="ret2List" max-height="500px">
                      <el-table-column width="120" property="projectName" align="center" label="项目名称" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="120" property="EmpName" align="center" label="员工姓名"></el-table-column>
                      <el-table-column width="160" property="StrIdCard" align="center" label="身份证号码"></el-table-column>
                      <el-table-column width="120" property="PhoneNum" align="center" label="手机号"></el-table-column>
                      <el-table-column width="90" property="SignatureStatus" align="center" label="是否签约"></el-table-column>
                    </el-table>
                    <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
                  </el-popover>
                  <!-- <el-button type="text" size="small">下载</el-button> -->
                </div>
                <div class="abnItem flex aic" v-if="IssuedThisMonthList.length > 0">
                  <!-- 共导入 100 条数据， -->
                  有 <span class="errNum">{{ IssuedThisMonthList.length }}</span>条数据本月同一个人有相同金额发薪数据
                  <el-popover placement="top" width="1000" trigger="click">
                    <el-table :data="IssuedThisMonthList" max-height="500px">
                      <el-table-column width="120" property="ProjectName" align="center" label="项目名称"></el-table-column>
                      <el-table-column width="120" property="PayrollNum" align="center" label="发薪编号"></el-table-column>
                      <el-table-column width="120" property="ProcessState" align="center" label="状态"></el-table-column>
                      <el-table-column width="120" property="EmployeeName" align="center" label="员工姓名"></el-table-column>
                      <el-table-column width="160" property="CardId" align="center" label="身份证号码"></el-table-column>
                      <el-table-column width="120" property="name" align="center" label="手机号"></el-table-column>
                      <el-table-column width="90" property="IssuedThisMonth" align="center" label="实发金额" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="150" property="UpdataTime" align="center" label="发放时间" :show-overflow-tooltip="true">
                        <template slot-scope={row}>
                          {{ row.UpdataTime ? row.UpdataTime.replace('T', ' ') : '' }}
                        </template>
                      </el-table-column>
                      <el-table-column width="90" property="nPayrollChannelame" align="center" label="发放渠道" :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column width="90" property="Subject" align="center" label="发薪主体" :show-overflow-tooltip="true"></el-table-column>
                    </el-table>
                    <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
                  </el-popover>
                  <!-- <el-button type="text" size="small">下载</el-button> -->
                </div>
              </div>

              <div class="abnItem flex aic" v-if="getprojectLogList.length > 0">
                <!-- 共导入 100 条数据， -->
                有 <span class="errNum">{{ getprojectLogList.length }}</span> 人入离职记录
                <el-popover placement="top" width="435px" trigger="click">
                  <el-table :data="ret2List" max-height="500px">
                    <el-table-column width="160" property="StrIdCard" align="center" label="身份证号码"></el-table-column>
                    <el-table-column width="140" property="DtEntryBdate" align="center" label="用工之日"></el-table-column>
                    <el-table-column width="140" property="离职日期" align="center" label="DtDepartureDate"></el-table-column>
                  </el-table>
                  <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
                </el-popover>
                <!-- <el-button type="text" size="small">下载</el-button> -->
              </div>

              <div class="abnItem flex aic" v-if="BankAccountCheckList.length > 0">
                <!-- 共导入 100 条数据， -->
                有 <span class="errNum">{{ BankAccountCheckList.length }}</span>条数据银行卡号异常
                <el-popover placement="top" width="500" trigger="click">
                  <el-table :data="BankAccountCheckList" max-height="500px">
                    <el-table-column width="120" property="EmployeeName" align="center" label="员工姓名"></el-table-column>
                    <el-table-column width="100" property="rowNum" align="center" label="行号"></el-table-column>
                    <el-table-column width="280" property="Val" align="center" label="异常提示"></el-table-column>
                  </el-table>
                  <el-button type="text" slot="reference" size="small" style="margin:0 10px;">查看</el-button>
                </el-popover>
                <!-- <el-button type="text" size="small">下载</el-button> -->
              </div>
            </div>
            <div v-if="IssuedThisMonthList.length == 0 && ret1List.length == 0 && ret1List.length == 0 && FormatCheckList.length == 0 && CardIdCheckList.length == 0" style="width:900px">
              <el-result icon="success" title="您的数据未发现异常数据,请点击下一步">
              </el-result>
            </div>
          </div>

          <!-- 完成算薪 -->
          <div class="finalSettlement" v-if="active == 2">
            <div v-if="formData.ApplySalary.PayType != '预支工资'">
              <div class="infoTitle">基本信息：
                <!-- <el-button type="text" size="small" @click="showBasicMore=!showBasicMore">{{ !showBasicMore ? '展开>>' : '收起>>' }} </el-button> -->
              </div>
              <div class="infoBox demandForm">
                <el-form :inline="true" label-width="110px">
                  <div class="basicInfo flex aic">
                    <el-form-item label="发薪项目:">
                      <div class="loongTxt" :title="baseInfo.ProjectName">
                        {{ baseInfo.ProjectName }}</div>
                    </el-form-item>
                    <el-form-item label="总应发金额:">{{ baseInfo.TotalResponse ?
                      baseInfo.TotalResponse.toFixed(2) :
                      '0.00' }}</el-form-item>
                    <el-form-item label="总实发金额:">{{ baseInfo.GrandTotal ?
                      baseInfo.GrandTotal.toFixed(2) :
                      '0.00' }}</el-form-item>
                    <el-form-item label="发薪总人数:">{{ baseInfo.TotalPayrolls }}</el-form-item>
                    <el-form-item label="发放途径:">{{ baseInfo.PayrollChannel }}</el-form-item>
                    <el-form-item label="申请发薪日:">{{ baseInfo.ApplicationDate }}</el-form-item>

                    <div v-if="showBasicMore">
                      <el-form-item label="客户名称:">
                        <div class="loongTxt" :title="baseInfo.CustomerName">
                          {{ baseInfo.CustomerName }}</div>
                      </el-form-item>
                      <el-form-item label="商务合同主体:">
                        <div class="loongTxt" :title="baseInfo.Subject">
                          {{ baseInfo.Subject }}</div>
                      </el-form-item>
                      <el-form-item label="归属月:">{{ baseInfo.AttrMonth }}</el-form-item>
                      <el-form-item label="申报月:">{{ baseInfo.IncomeTaxMonth }}</el-form-item>
                      <el-form-item label="社保公积金:">{{ baseInfo.AmountSocialSecurityFund
                        }}</el-form-item>
                      <el-form-item label="专项扣除:">{{ baseInfo.SpecialDeduction }}</el-form-item>
                      <el-form-item label="个税:">{{ baseInfo.PersonalIncomeTax }}</el-form-item>
                      <el-form-item label="本月批次:">{{ baseInfo.ThisMonthBatch }}</el-form-item>
                      <el-form-item label="个税申报类型:">{{ baseInfo.IncomeTaxType }}</el-form-item>
                      <el-form-item label="" label-width="120px">
                        <div>
                          <el-checkbox v-model="baseInfo.PersonalTaxIsBorne" true-label="个税由个人承担" false-label="" disabled>个税由个人承担</el-checkbox>
                        </div>
                      </el-form-item>
                      <el-form-item label="银行发放人数:">{{ }}</el-form-item>
                      <el-form-item label="银行实发:">{{ }}</el-form-item>
                      <el-form-item label="现金工资人数:">{{ }}</el-form-item>
                      <el-form-item label="现金工资金额:">{{ }}</el-form-item>
                      <el-form-item label="暂扣人数:">{{ }}</el-form-item>
                      <el-form-item label="暂扣:">{{ }}</el-form-item>
                      <el-form-item label="暂扣补发人数:">{{ }}</el-form-item>
                      <el-form-item label="暂扣补发:">{{ }}</el-form-item>
                      <div class="loongItem">
                        <el-form-item label="指定发放银行账户:" label-width="130px">{{ ApplySalaryExt.SpecifyBankAccount ? ApplySalaryExt.BankAccount : '-'}}</el-form-item>
                      </div>
                      <div class="loongItem">
                        <el-form-item label="申请备注:">{{ baseInfo.ApplyforRemark }}</el-form-item>
                      </div>
                      <div class="loongItem">
                        <el-form-item label="发薪摘要:">{{ baseInfo.PayrollSummary }}</el-form-item>
                      </div>
                      <el-form-item label="审批备注:">{{ baseInfo.ApprovalRemark }}</el-form-item>
                      <!-- <span>
                  <el-form-item label="商务合同主体：" label-width="120px">{{baseInfo.Subject}}</el-form-item>
                </span> -->
                      <el-form-item label="导入表:"> <span v-if="baseInfo.PayScaleRul" @click="down(baseInfo.PayScaleRul, headPath)" class="down cp">下载</span></el-form-item>
                      <el-form-item label="客户原表:">
                        <!-- <span v-if="baseInfo.CustomerOriginalTableRul" @click="downCOT(baseInfo.CustomerOriginalTableRul)" class="down cp">下载</span> -->
                        <div v-for="(item, index) in fileList2" :key="index" class="cp flex">
                          <div><i class="el-icon-document"></i></div>
                          <div class="cotName">{{ item.name }}</div>
                          <div class="down" @click="down2(item.url, docHeadPath, item.name)">
                            下载</div>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="showMore cp" @click="showBasicMore = !showBasicMore">
                <i :class="!showBasicMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:16px;"></i>
                {{ !showBasicMore ? '展开' : '收起' }}
              </div>

              <!-- <div class="infoTitle incInfo">客户到款信息：
              <el-button type="text" size="small" @click="getPayMore">{{ !showPayMore ? '展开>>' : '收起>>' }} </el-button>
            </div> -->
              <!-- <div v-if="showPayMore" class="showPaymentInfo">
              <el-table :data="PaymentData" ref="multipleTable" class="doc_table" @selection-change="handleSelectionChange" style="width:100%;margin-bottom: 20px;">
                <el-table-column type="selection" width="60" fixed="left">
                </el-table-column>
                <el-table-column prop="s2.PaymentNum" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
                </el-table-column>
                <el-table-column prop="s2.TransactionSerialNumber" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="s2.BankTransactionDate" label="到款时间" width="155" align="center">
                  <template slot-scope={row}>
                    {{ row.s2.BankTransactionDate ? row.s2.BankTransactionDate.replace('T',' ') : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="s2.OppositeOpeningBank" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="s2.AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="s2.IncurredAmount" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="r.AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="r.EmainingAvailableCredit" label="可用金额" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="r.ProjectName" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="s2.OppositeName" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="r.CreateTime" label="认领时间" width="155" align="center">
                  <template slot-scope={row}>
                    {{ row.r.CreateTime ? row.r.CreateTime.replace('T',' ') : '' }}
                  </template>

                </el-table-column>
              </el-table>

              <el-form-item>
                <el-checkbox v-model="NeedApplyDeposit">需要申请垫支</el-checkbox>
                <el-input v-model="formData.ApplySalary.ApplyDeposit" :disabled="!NeedApplyDeposit" placeholder="请输入垫资金额" style="width:200px;margin-left: 20px;" size="small"></el-input>
              </el-form-item>
            </div> -->

              <el-form :inline="true" v-if="baseInfo != {}">
                <el-form-item label="个税计算方式" prop="name">
                  <el-select v-model="baseInfo.PersonalIncomeTaxDataSource" placeholder="" size="small" style="width: 150px;" filterable disabled>
                    <el-option value="税局计算"></el-option>
                    <el-option value="按导入数据"></el-option>
                    <!-- <el-option value="系统计算"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item label="个税申报类型" prop="IncomeTaxType">
                  <el-select v-model="baseInfo.IncomeTaxType" placeholder="" size="small" style="width: 150px;" filterable>
                    <el-option value="正常工资薪金"></el-option>
                    <!-- <el-option value="劳务报酬"></el-option> -->
                    <el-option value="全年一次性奖金（一次扣税）"></el-option>
                    <el-option value="全年多次性奖金（多次发放）"></el-option>
                    <el-option value="解除劳动合同一次性补偿"></el-option>
                    <!-- <el-option value="个税差额补发"></el-option> -->
                  </el-select>
                </el-form-item>
                <!-- <el-form-item v-if="baseInfo.IncomeTaxType == '全年一次性奖金'">
                <div style="width:300px;padding-left: 10px;">
                  <el-checkbox v-model="AnnualOneTimeBonus2">本年度还有一次性奖金发放</el-checkbox>
                </div>
              </el-form-item> -->

              </el-form>

              <div class="flex">
                <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
                  <el-tab-pane label="算薪结果明细" name="0"></el-tab-pane>
                  <el-tab-pane label="原始导入明细" name="1"></el-tab-pane>
                </el-tabs>
                <div class="calcTips">注：税局计算个税中，可能需要等待3~5分钟，请耐心等待</div>
              </div>
              <!-- <el-tabs v-model="activeName2" v-if="activeName=='0'" @tab-click="getApplicationPayrollDetail('','')">
              <el-tab-pane label="全部" name="6"></el-tab-pane>
              <el-tab-pane label="校验成功" name="1"></el-tab-pane>
              <el-tab-pane label="校验失败" name="3"></el-tab-pane>
              <el-tab-pane label="未校验" name="0"></el-tab-pane>
            </el-tabs> -->
              <div v-if="activeName == '0'">
                <div class="flex sb">
                  <div class="ftabBtn flex">
                    <el-button type="primary" size="small" @click="exportDtl" :loading="isExpLoading">导出工资单</el-button>
                    <el-button type="primary" style="background:#5EC38C;color:#fff" size="small" @click="exportTaxDtl" :loading="isTaxExpLoading">导出算税明细</el-button>
                    <!-- <el-button type="success" size="small">重新导入</el-button> -->
                    <!-- <el-button type="success" size="small" @click="taxReg" v-if="baseInfo.IncomeTaxType!='个税差额补发'">选中身份校验</el-button> -->

                    <el-button type="warning" size="small" v-if="baseInfo.IncomeTaxType != '个税差额补发'" @click="allTaxSigning('1')">整批身份校验</el-button>


                    <!-- <el-button type="danger" size="small" @click="getTax">选中个税计算</el-button> -->

                    <el-popconfirm title="税局获取个税获取需等待5~10分钟，请确认是否继续获取？" style="margin: 0 10px;" @confirm="continueGetTax" v-if="baseInfo.IncomeTaxType != '个税差额补发'">
                      <el-button type="primary" style="background:rgba(199, 21, 133, 1);color:#fff;border-color: rgba(199, 21, 133, 1);" size="small" slot="reference" :loading="taxLoading">整批个税计算</el-button>
                    </el-popconfirm>
                    <el-button type="primary" size="small" @click="toZeroList">零收入补算税记录</el-button>
                    <el-button size="small" @click="FillSystemDataAdvanceWages">预支工资批量填写系统数据
                      <el-tooltip placement="top" effect="light">
                        <div slot="content" class="JobClasssTip cp">
                          预支工资系统待核销余额“复制到”预支工资“字段，如税后扣款合计金额>税后应发金额，则预支工资=税后应发金额-其他税后扣款金额（不含预支工资）
                        </div>
                        <i class="el-icon-question cp" style="color: #F56C6C"></i>
                      </el-tooltip>
                    </el-button>

                    <el-popconfirm :title="`请确认选中的 ${multipleSelection2.length} 条数据是否暂扣操作？`" style="margin: 0 10px;" @confirm="batchDetain">
                      <el-button slot="reference" size="small" style="background:rgba(199, 21, 133, 1);color:#fff;border-color: rgba(199, 21, 133, 1);">批量暂扣
                      </el-button>
                    </el-popconfirm>
                  </div>
                  <!-- <el-popconfirm title="税局获取个税获取需等待1~5分钟，请确认是否继续获取？" style="margin: 0 10px;" @confirm="getTax()" v-if="baseInfo.IncomeTaxType!='个税差额补发'"> -->
                  <!-- <div class="ftabBtn flex">
                  <el-button type="primary" size="small" @click="getApplicationPayrollDetail('3','')">手动刷新</el-button>
                  
                </div> -->
                </div>
                <div style="margin-bottom:15px">
                  <el-select v-model="listQuery.checkState" placeholder="税局校验状态" size="small" style="width: 180px;margin-left:15px" clearable filterable @change="getApplicationPayrollDetail('', '')">
                    <el-option label="校验成功" value="4"></el-option>
                    <el-option label="校验中" value="2"></el-option>
                    <el-option label="校验失败" value="3"></el-option>
                    <el-option label="未校验" value="1"></el-option>
                  </el-select>

                  <el-select v-model="listQuery.taxState" placeholder="个税计算状态" size="small" style="width: 180px;margin:0 15px" clearable filterable @change="getApplicationPayrollDetail('', '')">
                    <el-option value="算税成功"></el-option>
                    <el-option value="算税失败"></el-option>
                    <el-option value="未算税"></el-option>
                  </el-select>
                  <el-button type="success" size="small" @click="getApplicationPayrollDetail('3', '')">刷新</el-button>
                </div>

                <div class="calcTableBox">
                  <el-table :data="dtlData" border class="doc_table" v-if="isOver" style="width:100%;" :loading="isloading" @selection-change="handleSelectionChange2" :max-height="tableHeight - 100">
                    <el-table-column type="selection" align="center" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
                      <template slot-scope="scope">
                        {{ (listQuery.pageNum - 1) * Number(listQuery.pageSize) + scope.$index +
                          1 }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="SendState" label="身份校验" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
                      <template slot-scope={row}>{{ row.SendState == '4' ? '校验成功' : row.SendState
                        == '2' ? '校验中' :
                        row.SendState == '1' || row.SendState == '0' || row.SendState == null ?
                          '未校验' : '校验失败'
                        }}</template>
                    </el-table-column>
                    <el-table-column prop="TaxBureauResults" label="个税计算" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
                      <template slot-scope={row}>
                        {{ row.TaxBureauResults ? row.TaxBureauResults : '未算税' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center" fixed="left">
                    </el-table-column>
                    <el-table-column prop="error" label="错误信息" width="200" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
                      <template>{{ baseInfo.ProjectName }} </template>
                    </el-table-column>
                    <el-table-column prop="ApplicationDate" label="申请发放日" width="110" :show-overflow-tooltip="true" align="center">
                      <template>{{ baseInfo.ApplicationDate }}</template>
                    </el-table-column>



                    <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="BankAccount" label="银行帐号" width="140" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
                      <!-- <template>{{ baseInfo.PayrollChannel }} </template> -->
                    </el-table-column>
                    <el-table-column prop="ReleaseMode" label="发放方式" width="80" :show-overflow-tooltip="true" align="center">
                      <!-- <template>{{ baseInfo.PayType }} </template> -->
                    </el-table-column>
                    <el-table-column prop="SpecifyBankAccount" label="指定发放银行账户" width="125" :show-overflow-tooltip="true" align="center">
                      <template slot-scope={row}>{{ row.SpecifyBankAccount == true ? '是' : row.SpecifyBankAccount == false ? '否' : '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="Remark1" label="打款备注" width="80" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="IssuedThisMonth" label="本月实发" width="80" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="IncludesTelephoneSubsidy" label="包含电话费补贴的税前应发" width="180" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.IncludesTelephoneSubsidy" type="number" size="small" @blur="getIssuedThisMonth(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="OtherTaxDeductible" label="其中其他可避税项目" width="140" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.OtherTaxDeductible" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="CommunicationCharge" label="其中通讯费" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.CommunicationCharge" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="PersonalSupport" label="个人承担养老" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.PersonalSupport" type="number" size="small" @blur="getBearCostSocialSecurity(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="PersonalCare" label="个人承担医疗" width="130" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.PersonalCare" type="number" size="small" @blur="getBearCostSocialSecurity(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="PersonalUnemployment" label="个人承担失业" width="130" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.PersonalUnemployment" type="number" size="small" @blur="getBearCostSocialSecurity(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="BearCostSocialSecurity" label="个人承担社保费用" width="130" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.BearCostSocialSecurity" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="ProvidentFundCosts" label="个人承担公积金费用" width="140" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.ProvidentFundCosts" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="IndividualIncomeTax" label="个人所得税" width="90" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.IndividualIncomeTax" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="AbourUnionFees" label="工会费" width="80" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.AbourUnionFees" size="small" type="number" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="DeductMealFee" label="扣餐费" width="80" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.DeductMealFee" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="CompanyDeductRentUtilities" label="企业扣房租水电" width="120" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.CompanyDeductRentUtilities" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="CompanyDeductsUtilities" label="公司扣房租水电" width="120" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.CompanyDeductsUtilities" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="OtherDeductions" label="其他扣款（税后）" width="130" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.OtherDeductions" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="AdvanceWages" label="预支工资" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.AdvanceWages" type="number" size="small" @blur="getTotalAfterTaxDeductions(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="TotalAfterTaxDeductions" label="税后扣款合计" width="100" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="DecimalPointBalance" label="小数点差额调整（默认为正数）" width="210" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.DecimalPointBalance" type="number" size="small" @blur="getTotalDeductible(row)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="TotalDeductible" label="扣除了所有费用的应扣合计" width="180" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="AmountSalaryPreviousMonth" label="当月历次发放工资金额首次工资额" width="220" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="AmountSalaryPreviousMonth2" label="当月历次发放工资金额二次工资额" width="220" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="AmountSalaryPreviousMonth3" label="当月历次发放工资金额三次工资额" width="220" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="AmountSalaryPreviousMonth4" label="当月历次发放工资金额四次工资额" width="220" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="ChildEducation" label="累计子女教育" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.ChildEducation" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="ContinuingEducation" label="累计继续教育" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.ContinuingEducation" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="HousingLoanInterest" label="累计住房贷款利息" width="130" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.HousingLoanInterest" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="AccumulatedHousingRent" label="累计住房租金" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.AccumulatedHousingRent" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="SupportElderlyCumulatively" label="累计赡养老人" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.SupportElderlyCumulatively" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="CumulativeInfantCareCosts" label="累计婴幼儿照护费用" width="140" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.CumulativeInfantCareCosts" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="AccumulatedPersonalPension" label="累计个人养老金" width="120" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.AccumulatedPersonalPension" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="PhoneNum" label="手机号码" width="120" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="EmploymentDay" label="用工之日" width="150" align="center">
                      <template slot-scope={row}>
                        <el-date-picker type="date" placeholder="" v-model="row.EmploymentDay" value-format="yyyy-MM-dd" :clearable="false" size="small" style="width:128px"></el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column prop="DischargeDate" label="离职日期" width="150" align="center">
                      <template slot-scope={row}>
                        <el-date-picker type="date" placeholder="" v-model="row.DischargeDate" value-format="yyyy-MM-dd" :clearable="false" size="small" style="width:128px"></el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column prop="Remark1" label="打款备注" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="PayrollCompany" label="发薪公司" width="100" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="PersonalTaxIsBorne" label="税费承担方式" width="100" :show-overflow-tooltip="true" align="center">
                      <template>{{ baseInfo.PersonalTaxIsBorne }}</template>
                    </el-table-column>
                    <el-table-column prop="name" label="本年历月应税工资累计" width="155" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="累计应纳税所得额" width="130" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="累计应扣缴税额" width="120" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="累计已预缴税额" width="120" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="累计应补(退)税额" width="130" :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="DebitMoney" label="未核销借支" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column> -->
                    <el-table-column prop="OtherAdjustments" label="其他调整" width="100" align="center">
                      <template slot-scope={row}>
                        <el-input v-model="row.OtherAdjustments" size="small" @blur="getIssuedThisMonth(row)"></el-input>
                      </template>
                    </el-table-column>


                    <el-table-column label="操作" align="center" fixed="right" width="280px">
                      <template slot-scope={row,$index}>
                        <div class="injuryTabBtn">
                          <el-button type="text" @click="readInfo(row, $index)">信息查看</el-button>
                          <el-button type="text" @click="editInfo(row, $index)">信息修改</el-button>
                          <el-popconfirm :title="row.TaxBureauResults ? '删除后将重新算税，请确定是否删除？' : '请确定是否删除？'" style="margin:0 10px;" @confirm="del(row)" v-if="dtlData.length > 1">
                            <el-button type="text" slot="reference">删除</el-button>
                          </el-popconfirm>
                          <el-button type="text" @click="zeroRecording(row)">零收入补录</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div v-if="activeName == '1'">
                <el-table :data="dtlData" border class="doc_table" style="width:100%;" @selection-change="handleSelectionChange2" :max-height="tableHeight - 100">
                  <el-table-column type="selection" width="40" fixed="left">
                  </el-table-column>
                  <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
                    <template slot-scope="scope">
                      {{ (listQuery.pageNum - 1) * Number(listQuery.pageSize) + scope.$index + 1
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="ApplicationDate" label="申请发放日" width="120" :show-overflow-tooltip="true" align="center">
                    <template>{{ baseInfo.ApplicationDate }}</template>
                  </el-table-column>
                  <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
                    <template>{{ baseInfo.ProjectName }} </template>
                  </el-table-column>
                  <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="BankAccount" label="银行帐号" width="80" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
                    <!-- <template>{{ baseInfo.PayrollChannel }} </template> -->
                  </el-table-column>
                  <el-table-column prop="ReleaseMode" label="发放方式" width="80" :show-overflow-tooltip="true" align="center">
                    <!-- <template>{{ baseInfo.PayType }} </template> -->
                  </el-table-column>
                  <el-table-column prop="Remark1" label="打款备注" width="150" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="IssuedThisMonth" label="本月实发" width="80" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="IncludesTelephoneSubsidy" label="包含电话费补贴的税前应发" width="180" align="center">
                  </el-table-column>
                  <el-table-column prop="OtherTaxDeductible" label="其中其他可避税项目" width="140" align="center">

                  </el-table-column>
                  <el-table-column prop="CommunicationCharge" label="其中通讯费" width="100" align="center">

                  </el-table-column>
                  <el-table-column prop="PersonalSupport" label="个人承担养老" width="100" align="center">

                  </el-table-column>
                  <el-table-column prop="PersonalCare" label="个人承担医疗" width="130" align="center">

                  </el-table-column>
                  <el-table-column prop="PersonalUnemployment" label="个人承担失业" width="130" align="center">

                  </el-table-column>
                  <el-table-column prop="BearCostSocialSecurity" label="个人承担社保费用" width="130" align="center">

                  </el-table-column>
                  <el-table-column prop="ProvidentFundCosts" label="个人承担公积金费用" width="140" align="center">

                  </el-table-column>
                  <el-table-column prop="IndividualIncomeTax" label="个人所得税" width="90" align="center">

                  </el-table-column>
                  <el-table-column prop="AbourUnionFees" label="工会费" width="80" align="center">

                  </el-table-column>
                  <el-table-column prop="DeductMealFee" label="扣餐费" width="80" align="center">

                  </el-table-column>
                  <el-table-column prop="CompanyDeductRentUtilities" label="企业扣房租水电" width="120" align="center">

                  </el-table-column>
                  <el-table-column prop="CompanyDeductsUtilities" label="公司扣房租水电" width="120" align="center">

                  </el-table-column>
                  <el-table-column prop="OtherDeductions" label="其他扣款（税后）" width="130" align="center">

                  </el-table-column>
                  <el-table-column prop="AdvanceWages" label="预支工资" width="100" align="center">
                  </el-table-column>
                  <el-table-column prop="DebitMoney" label="预支工资系统待核销余额" width="200" align="center">
                  </el-table-column>

                  <el-table-column prop="TotalAfterTaxDeductions" label="税后扣款合计" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="DecimalPointBalance" label="小数点差额调整（默认为正数）" width="210" align="center">

                  </el-table-column>
                  <el-table-column prop="TotalDeductible" label="扣除了所有费用的应扣合计" width="180" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AmountSalaryPreviousMonth" label="当月历次发放工资金额首次工资额" width="220" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AmountSalaryPreviousMonth2" label="当月历次发放工资金额二次工资额" width="220" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AmountSalaryPreviousMonth3" label="当月历次发放工资金额三次工资额" width="220" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AmountSalaryPreviousMonth4" label="当月历次发放工资金额四次工资额" width="220" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="ChildEducation" label="累计子女教育" width="100" align="center">

                  </el-table-column>
                  <el-table-column prop="ContinuingEducation" label="累计继续教育" width="100" align="center">

                  </el-table-column>
                  <el-table-column prop="HousingLoanInterest" label="累计住房贷款利息" width="130" align="center">

                  </el-table-column>
                  <el-table-column prop="AccumulatedHousingRent" label="累计住房租金" width="100" align="center">

                  </el-table-column>
                  <el-table-column prop="SupportElderlyCumulatively" label="累计赡养老人" width="100" align="center">

                  </el-table-column>
                  <el-table-column prop="CumulativeInfantCareCosts" label="累计婴幼儿照护费用" width="140" align="center">

                  </el-table-column>
                  <el-table-column prop="AccumulatedPersonalPension" label="累计个人养老金" width="120" align="center">

                  </el-table-column>
                  <el-table-column prop="PhoneNum" label="手机号码" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="EmploymentDay" label="用工之日" width="150" align="center">

                  </el-table-column>
                  <el-table-column prop="DischargeDate" label="离职日期" width="150" align="center">

                  </el-table-column>
                  <el-table-column prop="Remark1" label="打款备注" width="150" align="center">
                  </el-table-column>
                  <el-table-column prop="PayrollCompany" label="发薪公司" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="PersonalTaxIsBorne" label="税费承担方式" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="本年历月应税工资累计" width="155" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="累计应纳税所得额" width="130" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="累计应扣缴税额" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="累计已预缴税额" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="累计应补(退)税额" width="130" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <!-- <el-table-column prop="DebitMoney" label="未核销借支" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column> -->
                  <el-table-column prop="OtherAdjustments" label="其他调整" width="100" align="center">

                  </el-table-column>

                  <el-table-column prop="name" label="备注" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                </el-table>
              </div>

              <div class="block">
                <el-pagination v-if="totalcount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
              </div>
            </div>
            <div v-else>
              <div class="infoBox" v-if="!isNull(baseInfo)">
                <div class="basicInfo flex">
                  <div class="infoItem">发薪项目: {{ baseInfo.ProjectName }}</div>
                  <div class="infoItem loongTxt">客户名称: {{ baseInfo.CustomerName }}</div>
                  <div class="infoItem">申请人: {{ baseInfo.Operator }}</div>
                  <div class="infoItem">归属月: {{ baseInfo.AttrMonth }}</div>
                  <div class="infoItem">发放途径: {{ baseInfo.PayrollChannel }}</div>
                  <div class="infoItem">预支工资金额: </div>
                  <div class="infoItem">实发金额: </div>
                  <div class="infoItem">个税: {{ baseInfo.PersonalIncomeTax }}</div>
                  <div class="infoItem">预支人数: </div>
                  <div class="infoItem">申请备注: {{ baseInfo.ApplicationRemarks }}</div>
                </div>
              </div>
              <el-table :data="dtlData" border class="doc_table" style="width:100%;" @selection-change="handleSelectionChange2" :max-height="tableHeight - 100">
                <el-table-column type="selection" width="40" fixed="left">
                </el-table-column>
                <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
                  <template slot-scope="scope">
                    {{ (listQuery.pageNum - 1) * Number(listQuery.pageSize) + scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="GrandTotal" label="实发金额" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="AdvanceWages" label="预支金额" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="IndividualIncomeTax" label="个税" width="90" align="center">
                </el-table-column>
                <el-table-column prop="name" label="是否在职" width="120" align="center">
                </el-table-column>
                <el-table-column prop="name" label="本月已预支金额" width="120" align="center">
                </el-table-column>
                <el-table-column prop="name" label="最近预支时间" width="120" align="center">
                </el-table-column>
                <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="PhoneNum" label="手机号码" width="130" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="BankAccount" label="银行帐号" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="PayrollCompany" label="发薪公司" width="80" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="Remark1" label="备注" width="150" :show-overflow-tooltip="true" align="center">
                </el-table-column>

                <el-table-column prop="SendState" label="身份校验" width="100" :show-overflow-tooltip="true" align="center">
                  <template slot-scope={row}>{{ row.SendState == '4' ? '校验成功' : row.SendState == '2' ?
                    '校验中' :
                    row.SendState == '1' || row.SendState == '0' || row.SendState == null ? '未校验' :
                      '校验失败' }}</template>
                </el-table-column>
                <el-table-column prop="TaxBureauResults" label="个税获取" width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="240px">
                  <template slot-scope={row,$index}>
                    <div class="injuryTabBtn">
                      <el-button type="text" @click="readInfo(row, $index)">信息查看</el-button>
                      <el-button type="text" @click="editInfo(row, $index)">信息修改</el-button>
                      <!-- <el-popconfirm title="请确定是否删除？" style="margin-left: 10px;" @confirm="del(row)">
                      <el-button type="text" slot="reference">删除</el-button>
                    </el-popconfirm> -->
                    </div>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </div>
        </div>
        <div class="btnBox">
          <el-button @click="cancel">返 回</el-button>
          <el-button v-if="active > 0 && ((this.$route.query.Id != undefined && this.active != 1) || this.$route.query.Id == undefined)" @click="goBack">上一步</el-button>
          <el-button v-if="active < 2" :loading="isloading" type="primary" @click="nextStep('nextStep')">{{
            active == 0
              ||
              (active == 1
                && IssuedThisMonthList.length == 0 && ret1List.length == 0 && ret1List.length == 0 &&
                BankAccountCheckList.length ==
                0) ? '下一步' : '确认，继续算薪' }}
          </el-button>
          <el-button v-if="active == 2" type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSubmit" :loading="btnLoading">保存修改</el-button>
          <!-- <el-button v-if="active==2" type="warning" v-preventReClick style="margin-left:10px;" @click="confirmSubmit">保存并申请发薪</el-button> -->
        </div>
      </div>
    </div>

    <el-dialog title="人员信息查看" :visible.sync="showRead" width="660px">
      <div class="readInfo" v-if="info != {} && showRead">
        <div class="readInfoItem1">姓名：{{ info.EmployeeName }}</div>
        <div class="readInfoItem1">身份证号码：{{ info.CardId }}</div>
        <div class="readInfoItem1">银行账号：{{ info.BankAccount }}</div>
        <div class="readInfoItem1">开户行：{{ info.DepositBank }}</div>
        <div class="readInfoItem1">手机号：{{ info.PhoneNum }}</div>
        <div class="readInfoItem1">发放方式：{{ info.ReleaseMode }}</div>
        <div class="readInfoItem1">用工之日：{{ info.EmploymentDay }}</div>
        <div class="readInfoItem1">离职日期：{{ info.DischargeDate }}</div>
        <div class="readInfoItem1">应发金额：{{ info.IncludesTelephoneSubsidy }}</div>
        <div class="readInfoItem1">发薪公司：{{ info.PayrollCompany }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRead = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="人员信息修改" :visible.sync="showEdit" width="900px">
      <div v-if="info != {} && showEdit">
        <el-form :model="info" :inline="true" ref="editInfo" :rules="rules" label-width="100px">
          <el-form-item label="姓名" prop="EmployeeName">
            <el-input v-model="info.EmployeeName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="CardId">
            <el-input v-model="info.CardId" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="应发金额" prop="IncludesTelephoneSubsidy">
            <el-input v-model="info.IncludesTelephoneSubsidy" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="银行帐号" prop="BankAccount">
            <el-input v-model="info.BankAccount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="DepositBank">
            <el-input v-model="info.DepositBank" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="PhoneNum">
            <el-input v-model="info.PhoneNum" style="width:300px" size="small"></el-input>
          </el-form-item>
          <!-- <el-form-item label="发放方式" prop="r.PayType">
          <el-input v-model="info.r.PayType" style="width:300px" size="small"></el-input>
        </el-form-item> -->
          <el-form-item label="用工之日" prop="EmploymentDay">
            <el-date-picker type="date" placeholder="" v-model="info.EmploymentDay" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="离职日期" prop="DischargeDate">
            <el-date-picker type="date" placeholder="" v-model="info.DischargeDate" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="发薪公司" prop="PayrollCompany">
          <el-input v-model="info.PayrollCompany" style="width:300px" size="small"></el-input>
        </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit">提
          交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批次确认" :visible.sync="showBatch" width="660px">
      <div>{{ formData.ApplySalary.ProjectName }} 项目该月已存在算薪数据，请确认是新的批次算薪数据，还是覆盖之前算薪数据？</div>
      <div style="margin-top: 10px;">该月已算薪批次如下：</div>
      <el-table :data="batchData" class="doc_table" style="width:100%;">
        <el-table-column prop="ThisMonthBatch" label="批次" width="60" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="生成时间" width="150" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{ row.CreateTime.replace('T', ' ') }}</template>
        </el-table-column>
        <el-table-column prop="TotalResponse" label="应发金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="TotalPayrolls" label="发放人数" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="AttrMonth" label="归属月" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ProcessState" label="状态" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showBatch = false">取
          消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="getBatch('add')">是新批次</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="getBatch('')">覆盖之前批次</el-button>
      </span>
    </el-dialog>

    <el-dialog title="重复导入" :visible.sync="showRepeat" width="740px">
      <div>以下人员出现在其他项目，请联系操作人确认入职时间等信息，以便算税准确</div>
      <el-table :data="repeatData" class="doc_table" style="width:100%;" max-height="500px">
        <el-table-column prop="Operator" label="客服" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <!-- <el-table-column prop="EmploymentDay" label="用工之日" min-width="120" :show-overflow-tooltip="true" align="center">
      </el-table-column> -->
        <el-table-column prop="ProjectName" label="项目名称" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeName" label="员工姓名" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="CardId" label="身份证" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showRepeat = false">取
          消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="addApplicationPayroll2()" :loading="isloading">确认，继续</el-button>
      </span>
    </el-dialog>

    <div class="dialogBox">
      <el-dialog title="数据错误提醒" :visible.sync="showError" :show-close="false" width="600px">
        <div v-if="FormatCheckList.length > 0">
          <div class="abnormalTitle"><i class="el-icon-warning"></i> 数据错误提醒：</div>
          <div class="errNumTips">本批发薪有<span class="errNum">{{ FormatCheckList.length
              }}</span>条数据格式有错误，请修改后再提交</div>
          <div class="abnItem" v-for="(item, index) in FormatCheckList" :key="index">
            {{ index + 1 }}、第 {{ item.rowNum }} 行，{{ item.Val }}
          </div>
          <!-- <div class="abnItem">
          <el-button type="text" size="small">更多</el-button>
          <el-button type="text" size="small">下载</el-button>
        </div> -->
        </div>

        <div v-if="CardIdCheckList.length > 0" style="margin-top:30px">
          <div class="abnormalTitle"><i class="el-icon-warning"></i> 系统风控提醒：</div>
          <div class="errNumTips">本批发薪有<span class="errNum">{{ CardIdCheckList.length
              }}</span>人有重复发薪数据，请修改后再提交。</div>
          <div class="abnItem" v-for="(item, index) in CardIdCheckList" :key="index">
            {{ index + 1 }}、第 {{ item.rowNum }} 行，{{ item.Val }}
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="closeErrorTip">返
            回</el-button>
        </span>
      </el-dialog>

      <el-dialog title="线下发薪数据维护确认" :visible.sync="showOfflineTips" :show-close="false" width="500px">
        <div>
          {{ formData.ApplySalary.ProjectName }}
          上月未使用数字化系统发薪，如本项目上月和本月有过线下发薪，为保证个税计算正确请导入上月和本月（如有）线下薪资表，如无或已导入请选择“无，不用导入”
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" v-preventReClick style="margin-left:10px;" size="small" @click="toOfflineTips">有，需导入</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="noImport">无，不用导入</el-button>
          <!-- <el-button @click="showOfflineTips = false" style="margin-left:10px;" size="small">取 消</el-button> -->
        </span>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="showBSTips" :show-close="false" width="500px">
        <div style="font-size: 16px;">
          报销款应先提交发票，再打款。报销发票是否提交给会计？
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="noBS">取 消</el-button>
          <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="showBSTips = false">确 认 </el-button>
        </span>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="showLWtips" :show-close="false" width="500px">
        <div style="font-size: 16px;">
          劳务报酬应先提交发票，再打款。劳务报酬发票是否提交给会计？
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="noLW">取 消</el-button>
          <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="showLWtips = false">确 认 </el-button>
        </span>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="showJCtips" :show-close="false" width="500px">
        <div style="font-size: 16px;">
          单人年度免税金额超十八万请与财务核对！
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="showJCtips = false">我已知晓 </el-button>
        </span>
      </el-dialog>
    </div>

    <el-dialog title="请确认以下人员将进行税局校验" :visible.sync="showTaxCheck" width="750px">
      <!-- <div class="taxCheckTitle"></div> -->
      <el-table :data="multipleSelection2" style="width: 100%">
        <el-table-column prop="ApplicationDate" label="申请发放日" width="110" :show-overflow-tooltip="true" align="center">
          <template>{{ baseInfo.ApplicationDate }}</template>
        </el-table-column>
        <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          <template>{{ baseInfo.ProjectName }} </template>
        </el-table-column>
        <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="BankAccount" label="银行帐号" width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showTaxCheck = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" :loading="isloading" @click="confirmTaxCheck">税局校验</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请确认以下人员将进行个税计算" :visible.sync="showTaxGet" width="750px">
      <!-- <div class="taxCheckTitle"></div> -->
      <el-table :data="multipleSelection2" style="width: 100%">
        <el-table-column prop="ApplicationDate" label="申请发放日" width="110" :show-overflow-tooltip="true" align="center">
          <template>{{ baseInfo.ApplicationDate }}</template>
        </el-table-column>
        <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          <template>{{ baseInfo.ProjectName }} </template>
        </el-table-column>
        <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="BankAccount" label="银行帐号" width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showTaxGet = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" :loading="isloading" @click="confirmTaxGet">个税获取</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog title="以下人员个税计算未成功，请确认是否继续？" :visible.sync="showTaxCheck2" width="900px">
    <el-table :data="taxCheckList" style="width: 100%">
      <el-table-column prop="EmployeeName" label="姓名" min-width="110" :show-overflow-tooltip="true" align="center">
      </el-table-column>
      <el-table-column prop="TaxBureauResults" label="个税计算结果" min-width="110" :show-overflow-tooltip="true" align="center">
      </el-table-column>
      <el-table-column prop="CardId" label="身份证号码" min-width="160" :show-overflow-tooltip="true" align="center">
      </el-table-column>
      <el-table-column prop="PhoneNum" label="手机号码" min-width="110" :show-overflow-tooltip="true" align="center">
      </el-table-column>
      <el-table-column prop="IssuedThisMonth" label="本月实发" min-width="80" :show-overflow-tooltip="true" align="center">
      </el-table-column>
      <el-table-column prop="PayrollCompany" label="发薪公司" min-width="100" :show-overflow-tooltip="true" align="center">
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="showTaxCheck2 = false">取 消</el-button>
      <el-button size="small" type="warning" v-preventReClick @click="downTaxCheck">下载名单</el-button>
      <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit2">确认,继续保存</el-button>
    </span>
  </el-dialog> -->

    <el-dialog title="发薪公司错误，请修改后重新导入" :visible.sync="showLegError" width="600px">
      <!-- <div class="taxCheckTitle"></div> -->
      <el-table :data="LegalSubjectCheckList" style="width: 100%">
        <el-table-column prop="rowNum" label="行号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="Val" label="错误" min-width="300" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showLegError = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showAllSign" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isSigning">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">
          人员校验进行中，预计耗时1~3分钟，请耐心等待......
        </div>
        <div class="CheckingTips">
          <span class="num1 success"> {{ checkSuccess }} </span>
          人已校验成功，<span class="num1 red"> {{ checkFail }} </span>人校验失败
        </div>
        <div class="footer">
          <el-button type="danger" size="small" @click="StopCheck" :loading="isloading">终止校验</el-button>
        </div>
      </div>
      <div v-if="!isSigning">
        人员校验结束，其中
        <span class="num1 success"> {{ checkSuccess }} </span>
        人校验成功，<span class="num1 red"> {{ checkFail }} </span>人校验失败
        <span v-if="checkFail > 0">
          ，可在 算薪结果明细 表格“错误信息”列查看错误信息，请修改人员信息后重新校验。
        </span>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isSigning">
        <!-- <el-button size="small" @click="showAllSign = false">关闭</el-button> -->
        <el-button size="small" type="primary" v-preventReClick :loading="taxLoading" @click="continueGetTax">继续算税</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showAllTax" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isTaxing">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">算税进行中，预计耗时1~5分钟，请耐心等待.....</div>
        <div class="CheckingTips" style="margin-top: 5px;">已用时：<span style="color: #f56c6c; font-weight: bold;">{{ taxElapsedText }}</span></div>
        <div style="text-align: center;">
          <span class="num1 success"> {{ taxSuccess }} </span>
          人已算税成功，<span class="num1 red"> {{ taxFail }} </span>
          人失败
        </div>
        <div class="footer">
          <el-button type="danger" size="small" @click="StopTax" :loading="isloading">终止算税</el-button>
        </div>
      </div>
      <div v-if="!isTaxing">
        算税结束，其中
        <span class="num1 success"> {{ taxSuccess }} </span>
        人算税成功，<span class="num1 red"> {{ taxFail }} </span>
        人失败
        <span v-if="taxNo > 0">，<span class="num1 red"> {{ taxNo }} </span>
          人未算税</span>
        <!-- <span v-if="taxFail>0">
        ，可在 算薪结果明细 表格“错误信息”列查看错误信息。请修改人员信息后重新校验，或确认继续对校验成功人员算税。
      </span> -->
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isTaxing">
        <el-button size="small" @click="showAllTax = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showZeroSign" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isZeroSigning">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">
          人员校验进行中，预计耗时1~3分钟，请耐心等待......
        </div>
      </div>
      <div v-if="!isZeroSigning">
        人员校验结束，其中
        <span class="num1 success"> {{ zeroCheckSuccess }} </span>
        人校验成功，<span class="num1 red"> {{ zeroCheckFail }} </span>人校验失败
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isZeroSigning">
        <!-- <el-button size="small" @click="showAllSign = false">关闭</el-button> -->
        <el-button size="small" type="primary" @click="getZeroTax">继续算税</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showZeroTax" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isZeroTaxing">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">算税进行中，预计耗时1~5分钟，请耐心等待.....</div>
        <!-- <div class="footer">
        <el-button type="danger" size="small" @click="StopTax" :loading="isloading">终止算税</el-button>
      </div> -->
      </div>
      <div v-if="!isZeroTaxing">
        算税结束，其中
        <span class="num1 success"> {{ zeroTaxSuccess }} </span>
        人算税成功，<span class="num1 red"> {{ zeroTaxFail }} </span>
        人失败
        <span v-if="zeroTaxNo > 0">，<span class="num1 red"> {{ zeroTaxNo }} </span>
          人未算税</span>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isZeroTaxing">
        <el-button size="small" @click="showZeroTax = false">关闭</el-button>
      </span>
    </el-dialog>


    <el-dialog title="零收入补录" :visible.sync="showZeroRecording" width="500px">
      <div v-if="info != {} && showZeroRecording">
        <el-form :model="info" ref="editInfo" label-width="100px">
          <el-form-item label="姓名" prop="EmployeeName">
            <el-input v-model="info.EmployeeName" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="CardId">
            <el-input v-model="info.CardId" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="申报月" prop="IncomeTaxMonth">
            <el-date-picker v-model="zeroForm.IncomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showZeroRecording = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmZeroRecording" :loading="zeroLoading">提
          交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="手机号异常" :visible.sync="showPhoneError" width="700px">
      <div style="font-size: 16px;">本次导入以下名单手机号和历史发薪手机号不符合,是否要替换现有手机号？(建议替换)</div>
      <div class="msgBox">
        <div v-for="(item, index) in errPhoneList" :key="index" class="msgItem">
          <div v-if="item.Type == 0">{{ item.msg }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" :loading="btnLoading" @click="phoneHandel(0)">不替换</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" :loading="btnLoading" @click="phoneHandel(1)">替换</el-button>
      </span>
    </el-dialog>

    <el-dialog title="手机号异常" :visible.sync="showPhoneError2" width="700px">
      <div style="font-size: 16px;">本次导入以下名单手机号已被其他员工占用，是否要系统生成虚拟号码?(建议生成)</div>
      <div class="msgBox">
        <div v-for="(item, index) in errPhoneList" :key="index" class="msgItem">
          <div v-if="item.Type == 1">{{ item.msg }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" :loading="btnLoading" @click="phoneHandel(5)">不需要</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" :loading="btnLoading" @click="phoneHandel(2)">需要</el-button>
      </span>
    </el-dialog>

    <el-dialog title="税局入职日期不一致提示" :visible.sync="showPhoneError3" width="800px">
      <div style="font-size: 16px;">入职日期与上月或本月税局登记的入职日期不一致，请确认采用税局入职日期。</div>
      <el-table :data="errPhoneList" style="width: 100%">
        <el-table-column prop="NewEmpName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="NewCardId" label="身份证号码" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ThisEmploymentDay" label="本次入职日期" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="TaxEmploymentDay" label="最近一次已发薪用工之日" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="TaxEmploymentDay" label="最近一次已发薪用工之日对应项目/客服" min-width="300" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.ProjectName + '/' + row.Operator }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" :loading="btnLoading" @click="showPhoneError3 = false">放弃导入</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" :loading="btnLoading" @click="taxSysHandel()">确认入职用税务系统日期</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    row
  } from "mathjs";
  export default {
    data() {
      return {
        showPhoneError3: false,
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          id: '',
          ids: '',
          CardId: '',
          PersonnelCheck: '',
          EmployeeName: '',
          BankAccount: '',
          checkState: '', //校验状态
          taxState: '', //算税状态
        },
        PayInjury: false, //属工伤工资
        AnnualOneTimeBonus: false, //全年一次性奖金
        PersonalTaxIsBorne: true,
        NeedApplyDeposit: false, //需申请垫资 
        repeatData: [],
        showRepeat: false,
        formData: {
          ApplySalary: {
            ProjectName: '',
            ProjectId: '',
            TaxTypeRemark: '', //共发放  / 报税月份 / 其他不算税内容为
            AttrMonth: '', //归属月份
            Subject: '', //商务合同主体
            IncomeTaxType: '', //个税申报类型
            PayType: '', //发放类型
            PayInjury: '', //正常工资薪金/为工伤工资
            AnnualOneTimeBonus: '', //本年度还有一次性奖金发放	
            InitialDataSource: '', //初始数据来源
            PayrollChannel: '', //发薪方式
            ApplicationRemarks: '', //申请备注
            PayScaleRUL: '', //薪资表url
            CustomerOriginalTableRul: '', //客户原表url
            PersonalIncomeTaxDataSource: '', //个税数据来源
            PersonalTaxIsBorne: '', //个税由个人承担
            ApplicationDate: '', //申请发放日期
            ImportTempName: '', //导入模板名
            ImportTempId: '', //导入模板ID
            ThisMonthBatch: '', //本月批次
            TotalResponse: '', //总应发
            GrandTotal: '', //总实发
            TotalPayrolls: '', //发薪总人数
            AmountSocialSecurityFund: '', //社保公积金金额
            SpecialDeduction: '', //专项扣除
            LandingCompany: '', //落地公司
            SpecifyBankAccount: null, //指定发放银行账户 bool
            BankAccount: '', //银行账户（指定发放银行账户=true 时使用）
            AssociatedClaim: '', //关联认领ID  字符串类型
            Cacucode: '', //算税批次号
            ApplyforRemark: '', //申请备注
            PayrollSummary: '', //发薪摘要
          },
          ckeck: "1", //1预览 /2入库
          userList: [],

        },
        bankList: [],
        SummaryPersonnelDetails: {},
        rules1: {
          'ApplySalary.PayType': {
            required: true,
            message: '请选择发放类型',
            trigger: 'change'
          },
          'ApplySalary.IncomeTaxType': {
            required: true,
            message: '请选择个税申报类型',
            trigger: 'change'
          },
          'ApplySalary.ProjectName': {
            required: true,
            message: '请选择发薪项目',
            trigger: 'change'
          },
          'ApplySalary.AttrMonth': {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          'ApplySalary.IncomeTaxMonth': {
            required: true,
            message: '请选择个税申报月',
            trigger: 'change'
          },
          'ApplySalary.ApplicationDate': {
            required: true,
            message: '请选择发薪日',
            trigger: 'change'
          },
          'ApplySalary.PersonalIncomeTaxDataSource': {
            required: true,
            message: '请选择个税计算方式',
            trigger: 'change'
          },
          'ApplySalary.Subject': {
            required: true,
            message: '请选择商务合同主体',
            trigger: 'change'
          },
          'ApplySalary.PayrollChannel': {
            required: true,
            message: '请选择发放途径',
            trigger: 'change'
          },
          'ApplySalary.LandingCompany': {
            required: true,
            message: '请选择落地公司',
            trigger: 'change'
          },
          'ApplySalary.InitialDataSource': {
            required: true,
            message: '请选择初始数据来源',
            trigger: 'change'
          },
          'ApplySalary.PayScaleRUL': {
            required: true,
            message: '请上传导入模板',
            trigger: 'change'
          },
          'ApplySalary.CustomerOriginalTableRul': {
            required: true,
            message: '请上传客户原表',
            trigger: 'change'
          },
          'ApplySalary.TaxTypeRemark': {
            required: true,
            message: '请输入',
            trigger: 'none'
          },
          'ApplySalary.ImportTempId': {
            required: true,
            message: '请选择模板',
            trigger: 'change'
          },
          'ApplySalary.ApplyforRemark': {
            required: true,
            message: '请输入申请备注',
            trigger: 'blur'
          }
        },
        CardIdCheckList: [], //系统风控提醒列表
        FormatCheckList: [], //格式错误列表
        IssuedThisMonthList: [], //相同金额列表
        ret1List: [], //商保信息对比不一致列表
        ret2List: [], //无签约
        showError: false, //导入数据错误 弹窗
        ThisMonthBatchMax: 1,
        showBatch: false, //批次选择弹窗
        batchData: [],
        AnnualOneTimeBonus2: false, //本年度还有一次性奖金发放
        sendWayList: [], //发放途径列表
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        activeName: 0,
        active: 0,
        activeName2: '6',
        isloading: false,
        ExcelSrc: {
          value: "",
          check: false,
          fileName: "",
        },
        ExcelSrc2: {
          value: "",
          check: false,
          fileName: "",
        },
        proNameList: [], //项目列表
        getprojectLogList: [],
        showPaymentInfo: false, //显示到款信息
        multipleSelection: [], //客户到款信息 选择的行
        multipleSelection2: [], //完成算薪 选择的行
        dtlData: [],
        baseInfo: {},
        ApplySalaryExt: {
          SpecifyBankAccount: false,
          BankAccount: '',
        },
        totalcount: 0,
        gridData: [{
          name: '666'
        }],
        incNum: 0, //不一致人数
        showBasicMore: false, //展开基本信息
        showPayMore: false, //展开客户到款信息
        showRead: false, //查看弹窗
        showEdit: false, //修改弹窗
        nextType: '', //上一步/下一步
        index: '',
        info: {},
        isOver: false, //是否加载完成
        PaymentData: [], //到款信息
        showTaxCheck: false, //税局校验弹窗
        showTaxGet: false,
        hasGetTax: false, //有没有点过获取个税
        interval: null,
        intervalNum: 0, //刷新次数
        taxTimer: null, //算税计时器
        taxElapsed: 0, //算税已耗时秒数
        checkQuery: {
          ID: '',
          pageNum: 1,
          pageSize: 10
        },
        supObjList: [], //特殊项目列表
        taxCheckUrl: '', //个税未获取名单下载url
        taxCheckList: [], //个税未获取名单
        // showTaxCheck2: false, //个税未获取弹窗
        btnLoading: false,
        taxLoading: false,
        fileList: [], //导入薪资表
        fileList2: [], //导入薪资表
        docHeadPath: this.$store.state.EMP.docPath,
        ids: '',
        showLegError: false,
        LegalSubjectCheckList: [], //发薪主体错误列表
        fileListPSR: [],
        showAllSign: false, //第三步默认全员登记弹窗
        isSigning: false, //登记中
        showAllTax: false, //第三步默认全员计算个税弹窗
        isTaxing: false, //计算个税中
        checkFail: 0, //校验失败数量
        checkSuccess: 0, //校验成功数量
        taxSuccess: 0, //个税计算成功数量
        taxFail: 0, //个税计算失败数量
        taxNo: 0, //未算税个数
        not1: '', //共发放
        not2: '', //报税月份
        taxState: '',
        tempData: {
          TempName: '',
          ImportTemplateUrl: '',
        },
        tempList: [],
        showOfflineTips: false,
        isExpLoading: false,
        isTaxExpLoading: false,
        showZeroRecording: false,
        zeroLoading: false,
        showZeroTax: false,
        legList: [],
        zeroTaxSuccess: 0, //零收入算税成功人数
        zeroTaxFail: 0,
        zeroTaxNo: 0,
        isZeroTaxing: false, //是否零收入算税中
        zeroCacucode: '',
        zeroId: '', //零收入Id
        showZeroSign: false,
        isZeroSigning: false,
        zeroCheckSuccess: 0,
        showJCtips: false,
        zeroCheckFail: 0,
        zeroForm: {
          IncomeTaxMonth: '', //零收入申报月
        },
        tableHeight: 0,
        SubjectList: [], //商务主体列表
        BankAccountCheckList: [], //银行卡校验异常列表
        both: false,
        phoneHandelNum: null,
        showPhoneError: false, //本次导入手机号和历史发薪手机号不符合
        showPhoneError2: false, //本次导入使用手机号和已被其他员工占用
        errPhoneList: [],
        showBSTips: false,
        showLWtips: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < new Date(moment().add(1, 'months').format('YYYY-MM'));
          },
        }
      }
    },
    created() {
      this.calHeight();
      this.getlegalsubjectlist();
      this.getProList();
      this.getDistributionChannelList();
      if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.active = Number(this.$route.query.active);
        this.ids = this.$route.query.ids;
        if (this.$route.query.PayType) {
          this.formData.ApplySalary.PayType = this.$route.query.PayType
        }
        if (this.active == 3) {
          this.active = 2;
          this.getApplicationPayrollDetail(this.$route.query.Id, 'getAllTax');
        } else {
          this.getApplicationPayrollDetail(this.$route.query.Id, 'reCalc');
        }
        localStorage.setItem("salaryId", '');
      } else if (localStorage.salaryId) {
        this.active = 2;
        this.getApplicationPayrollDetail(localStorage.salaryId, 'reCalc');
      } else {
        let now = new Date();
        this.formData.ApplySalary.AttrMonth = moment(now).subtract(1, 'months').format('YYYY-MM');
        this.formData.ApplySalary.IncomeTaxMonth = moment(now).add(1, 'months').format('YYYY-MM');
        this.formData.ApplySalary.ApplicationDate = new Date().getDate() + '日';
      }
      // this.getApplicationPayrollDetail('a4bc5833-da9e-4bb5-9c53-438176404ae9');
      // this.bbb();
    },
    beforeDestroy() {
      // 清除setInterval
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.clearTaxTimer();
    },
    onUnmounted() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.clearTaxTimer();
    },
    computed: {
      //算税已耗时格式化 mm:ss
      taxElapsedText() {
        const s = Math.max(0, this.taxElapsed);
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return (m < 10 ? '0' + m : m) + ':' + (sec < 10 ? '0' + sec : sec);
      }
    },
    methods: {
      checkPermission,
      //获取表格高度
      calHeight() {
        this.tableHeight = Number(document.documentElement.clientHeight);
        console.log("height", this.tableHeight);
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取发放途径
      getDistributionChannelList() {
        let data = {
          ChannelName: '',
          pageNum: 1,
          pageSize: 10000
        }
        xz.getDistributionChannelList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.sendWayList = res.data.data;
          } else {
            this.sendWayList = [];
          }
        })
      },
      changeTab() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      getList() {
        if (this.activeName == '0') {
          this.getApplicationPayrollDetail('', '');
        } else {
          this.DailyInspectionWarrantyLapse();
        }
      },
      //选择发放类型
      changeWay(val) {
        this.PayInjury = false;
        if (val == '预支工资') {
          this.formData.userList = [{
            EmployeeName: '', //姓名
            CardId: '', //身份证号码
            BankAccount: '', //银行帐号
            DepositBank: '', //开户行
            PhoneNum: '', //电话
            IndividualIncomeTax: '', //应扣个税
            IssuedThisMonth: '', //实发金额
            AdvanceWages: '', //预支金额
            Cardholder: '', //持卡人
          }]
        }
      },
      //新增
      addLine() {
        let data = {
          EmployeeName: '', //姓名
          CardId: '', //身份证号码
          BankAccount: '', //银行帐号
          DepositBank: '', //开户行
          PhoneNum: '', //电话
          IndividualIncomeTax: '', //应扣个税
          IssuedThisMonth: '', //实发金额
          AdvanceWages: '', //预支金额
          Cardholder: '', //持卡人
          PayrollCompany: this.formData.ApplySalary.Subject
        }
        console.log(this.Subject)
        this.formData.userList.push(data)
      },
      //删除
      delLine(index) {
        this.formData.userList.splice(index, 1)
      },
      //选择项目
      changePro(val) {
        this.PaymentData = [];
        this.showPaymentInfo = false;
        this.formData.ApplySalary.ProjectId = val.Projectid;
        this.formData.ApplySalary.ProjectName = val.StrprojectName;
        this.formData.ApplySalary.ThisMonthBatch = '';
        xz.getProjectDetailversion1(val.Projectid).then(res => {
          if (res.status == 'ok') {
            if (res.msgsub.length > 0) {
              const map = new Map();
              res.msgsub.forEach(item => {
                if (!map.has(item.StrSignsubjectName)) {
                  map.set(item.StrSignsubjectName, item);
                }
              });
              this.SubjectList = Array.from(map.values());
              this.formData.ApplySalary.Subject = res.msgsub[0].StrSignsubjectName
            }
          }
        })
        let d = {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          id: '',
          pojectId: val.Projectid,
          pojectName: val.StrprojectName,
          msg: ''
        }
        xz.ArdCurStat(d, 'GetProjectLoadingDistributioPath').then(res => {
          if (res.status == 'ok') {
            this.supObjList = res.data.data;
          } else {
            this.supObjList = [];
          }
        })
        if (this.formData.ApplySalary.ProjectId && this.formData.ApplySalary.IncomeTaxType && this.formData.ApplySalary.IncomeTaxMonth) {
          this.getProjectMonthBatch();
        }
        this.getTempList();
      },
      getTempList() {
        let tempData = {
          pageNum: 1,
          pageSize: 100,
          BusinessType: this.formData.ApplySalary.PayType == '其他' ? 3 : 1,
          ProjectName: this.formData.ApplySalary.ProjectName
        }
        xz.getImportTempList(tempData, this.roletype).then(res => {
          if (res.status == 'ok') {
            // let data = {
            //   TempName: '系统模板',
            //   ImportTemplateUrl: this.formData.ApplySalary.PayType == '正常发薪' || this.formData.ApplySalary.PayType == '工资' ? 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20240319181158290.xlsx' : 'excel/9c895257-5e33-4888-9bd8-adb6df000028/E20240131165602705.xlsx',
            // }
            // res.data.data.unshift(data)
            this.tempList = res.data.data;
            this.tempData = this.tempList[0];
            this.formData.ApplySalary.ImportTempId = this.tempList[0].Id;
          }
        })
      },
      changeIncomeTaxMonth() {
        this.$forceUpdate();
        this.PaymentData = [];
        this.showPaymentInfo = false;
        this.formData.ApplySalary.ThisMonthBatch = '';
        if (this.formData.ApplySalary.ProjectId && this.formData.ApplySalary.IncomeTaxType && this.formData.ApplySalary.IncomeTaxMonth) {
          this.getProjectMonthBatch();
        }
      },
      //选择个税申报类型
      changeIncomeTaxType(val) {
        this.formData.ApplySalary.ThisMonthBatch = '';
        if (this.formData.ApplySalary.ProjectId && this.formData.ApplySalary.IncomeTaxType && this.formData.ApplySalary.IncomeTaxMonth) {
          this.getProjectMonthBatch();
        }
        if (val == '劳务报酬') {
          this.showLWtips = true;
        } else if (val == '解除劳动合同一次性补偿') {
          this.showJCtips = true;
        }
      },
      //选择发放类型
      changePayType() {
        if (this.formData.ApplySalary.PayType == '其他') {
          this.formData.ApplySalary.IncomeTaxType = '不算税';
          this.formData.ApplySalary.PersonalIncomeTaxDataSource = '按导入数据';
        } else if (this.formData.ApplySalary.PayType == '预支工资') {
          this.addLine();
        } else {
          this.formData.ApplySalary.IncomeTaxType = '';
          this.formData.ApplySalary.PersonalIncomeTaxDataSource = '';
        }
        this.formData.ApplySalary.ThisMonthBatch = '';
        if (this.formData.ApplySalary.ProjectId && this.formData.ApplySalary.IncomeTaxType && this.formData.ApplySalary.IncomeTaxMonth) {
          this.getProjectMonthBatch();
          this.getProjectMonthBatch2();
        }
      },
      getProjectMonthBatch() {
        // let now = new Date();
        // let data = {
        //   projectName: this.formData.ApplySalary.ProjectName,
        //   IncomeTaxMonth: moment(now).subtract(1, 'months').format('YYYY-MM')
        // }
        // xz.AdvanceFun(data, 'CheckTaxeLastMonth').then(res => {
        //   if (res.status == 'ok') {
        //     if (res.data == 0) {
        //       this.showOfflineTips = true;
        //     }
        //   } else {
        //     this.$message.error('批次获取失败')
        //   }
        // })
      },
      noImport() {
        this.showOfflineTips = false;
        this.getProjectMonthBatch2();
      },
      toOfflineTips() {
        this.$router.push({
          path: '/offlineSalary'
        })
      },
      //查询本月批次
      getProjectMonthBatch2() {
        let data = {
          projectid: this.formData.ApplySalary.ProjectId,
          IncomeTaxType: this.formData.ApplySalary.IncomeTaxType,
          IncomeTaxMonth: this.formData.ApplySalary.IncomeTaxMonth,
        }
        xz.getProjectMonthBatch(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.ChannelNameList.length > 0) {
              this.batchData = res.data.ChannelNameList;
              this.ThisMonthBatchMax = Number(res.data.ThisMonthBatchMax);
              this.showBatch = true;
            } else {
              this.formData.ApplySalary.ThisMonthBatch = 1;
            }
          } else {
            this.$message.error('批次获取失败')
          }
        })
      },
      getBatch(type) {
        if (type == 'add') { //新批次
          this.formData.ApplySalary.ThisMonthBatch = this.ThisMonthBatchMax + 1;
          // console.log(this.formData.ApplySalary.ThisMonthBatch)
        } else {
          //覆盖
          if (this.batchData[0].Cacucode) {
            this.formData.ApplySalary.Cacucode = this.batchData[0].Cacucode;
          }
          this.formData.ApplySalary.ThisMonthBatch = this.ThisMonthBatchMax;
        }
        this.showBatch = false;
      },
      //下载模板
      downTemp() {
        // if (this.formData.ApplySalary.PayType) {
        //   let path = '';
        //   if (this.formData.ApplySalary.PayType == '正常发薪' || this.formData.ApplySalary.PayType == '工资') {
        //     // path = this.headPath + "excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20240227110242353.xlsx";
        //     path = this.headPath + "excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20240319181158290.xlsx"
        //   } else {
        //     path = this.headPath + 'excel/9c895257-5e33-4888-9bd8-adb6df000028/E20240131165602705.xlsx';
        //   }
        if (this.formData.ApplySalary.PayrollChannel == '现金') {
          let path = this.headPath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20240725093303513.xlsx';
          const aTag = document.createElement('a')
          aTag.href = path;
          aTag.download = "现金-发放模版.xlsx";
          aTag.click();
        } else if (this.formData.ApplySalary.PayType == '其他') {
          // let path = this.headPath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20240717154540994.xlsx';
          let path = this.headPath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20240923175033864.xlsx';
          const aTag = document.createElement('a')
          aTag.href = path;
          aTag.download = "其他-发放模版.xlsx";
          aTag.click();
        } else if (this.formData.ApplySalary.PayType == '工伤工资') {
          // let path = this.headPath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20240717154540994.xlsx';
          let path = this.headPath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20240923174952424.xlsx';
          const aTag = document.createElement('a')
          aTag.href = path;
          aTag.download = "工伤工资算税模板.xlsx";
          aTag.click();
        } else if (this.formData.ApplySalary.PersonalIncomeTaxDataSource == '税局计算') {
          let path = this.headPath + this.tempData.ImportTemplateUrl
          const aTag = document.createElement('a')
          aTag.href = path;
          aTag.download = "我司算税模板.xlsx";
          aTag.click();
        } else {
          let path = this.headPath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20240605161754392.xlsx';
          const aTag = document.createElement('a')
          aTag.href = path;
          aTag.download = "按客户算税模版.xlsx";
          aTag.click();
        }
      },
      downAdvTemp() {
        let path = this.headPath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20240603104515306.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      //薪资表读取
      async importf() {
        const fileInput = this.$refs.upload;
        FUN.returnExcelSrc(fileInput).then((src) => {
          if (src) {
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            // console.log('srccc', this.ExcelSrc)
            //上传excel
            const excelFile = FUN.base64ToFile(
              this.ExcelSrc.value,
              this.ExcelSrc.fileName
            );
            const formData = new FormData();
            formData.append("pagename", "empexcel");
            formData.append("action", "save");
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            xz.uploadCert(formData).then((res) => {
              if (this.isNull(res) || res == false) {
                this.$message("上传Excel失败!");
                this.$refs['upload'].value = null;
              } else {
                this.formData.ApplySalary.PayScaleRUL = res;
                this.$refs['upload'].value = null;
                this.formData.userList = [];
                // console.log(this.formData)
              }
            });
          } else {
            this.$message("上传Excel失败!");
            this.$refs['upload'].value = null;
          }
        });
      },
      //客户原表读取
      async importf2() {
        const fileInput = this.$refs.upload2;
        console.log('222', fileInput)
        FUN.returnExcelSrc(fileInput).then((src) => {
          if (src) {
            this.$set(this.ExcelSrc2, "value", src.src);
            this.$set(this.ExcelSrc2, "check", false);
            this.$set(this.ExcelSrc2, "fileName", fileInput.files[0].name);
            //上传excel
            const excelFile = FUN.base64ToFile(
              this.ExcelSrc2.value,
              this.ExcelSrc2.fileName
            );
            const formData = new FormData();
            formData.append("pagename", "empexcel");
            formData.append("action", "save");
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile, this.ExcelSrc2.fileName);
            xz.uploadCert(formData).then((res) => {
              if (this.isNull(res) || res == false) {
                this.$message("上传Excel失败!");
                this.$refs['upload2'].value = null;
              } else {
                this.formData.ApplySalary.CustomerOriginalTableRul = res;
                this.$refs['upload2'].value = null;
              }
            });
          } else {
            this.$message("上传Excel失败!");
            this.$refs['upload2'].value = null;
          }
        });
      },
      //下一步/上一步
      nextStep(type) {
        this.nextType = type;
        if (this.baseInfo.Id) {
          this.active++
        } else {
          if (this.active == 0) {
            // 申请备注含银行/专户/共管户/银行账号字眼时，必须指定发放银行账户并选择账户
            const remark = this.formData.ApplySalary.ApplyforRemark || '';
            const bankKeywords = ['银行', '专户', '共管户', '银行账号'];
            const hasBankKeyword = bankKeywords.some(kw => remark.indexOf(kw) > -1);
            if (hasBankKeyword && this.formData.ApplySalary.SpecifyBankAccount != true) {
              this.$message({
                message: '请将"指定发放银行账户"选择为"是"并选择银行账户后再提交。',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (hasBankKeyword && this.formData.ApplySalary.SpecifyBankAccount == true && !this.formData.ApplySalary.BankAccount) {
              this.$message({
                message: '已选择"指定发放银行账户=是"，请选择具体的银行账户后再提交。',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (this.formData.ApplySalary.PayrollSummary.indexOf('工资') > -1 || this.formData.ApplySalary.PayrollSummary.indexOf('薪酬') > -1) {
              this.$message({
                message: '发薪摘要不能填 “工资”、“薪酬” 这两个字眼，请用“报酬”替代。',
                type: 'warning',
                duration: 5000
              })
            } else {
              this.addApplicationPayroll();
            }
          } else if (this.active == 1) {
            this.formData.ckeck = '2';
            this.Warehousing()
          }
        }
      },
      goBack() {
        this.active--;
      },
      //第一步  数据校验
      addApplicationPayroll() {
        if (this.fileList.length > 0) {
          this.formData.ApplySalary.CustomerOriginalTableRul = JSON.stringify(this.fileList)
        }
        if (this.formData.ApplySalary.IncomeTaxType == '全年多次性奖金（多次发放）' && this.not1 && this.not2) {
          this.formData.ApplySalary.TaxTypeRemark = this.not1 + ',' + this.not2;
        }
        this.$refs["salaryForm"].validate((valid) => {
          if (valid) {
            // if (this.formData.ApplySalary.ThisMonthBatch) {
            this.formData.ckeck = '1';
            // if (this.PayInjury) {
            //   this.formData.ApplySalary.PayInjury = '属工伤工资'
            // }
            if (this.AnnualOneTimeBonus) {
              this.formData.ApplySalary.AnnualOneTimeBonus = '本年度还有一次性奖金发放'
            }
            if (this.PersonalTaxIsBorne) {
              this.formData.ApplySalary.PersonalTaxIsBorne = '个税由个人承担'
            } else {
              this.formData.ApplySalary.PersonalTaxIsBorne = '个税由企业承担'
            }
            if (this.NeedApplyDeposit) {
              this.formData.ApplySalary.NeedApplyDeposit = '需要申请垫资'
            }
            // if (this.multipleSelection.length > 0) {
            //   let arr = []
            //   this.multipleSelection.forEach(element => {
            //     arr.push(element.r.Id)
            //   });
            //   this.formData.ApplySalary.AssociatedClaim = arr.toString();
            // }
            this.isloading = true;
            xz.CheckPerson(this.formData, this.roletype).then(res => {
              console.log(res)
              if (res.status == 'ok') {
                if (res.data.length > 0) {
                  this.repeatData = res.data
                  this.showRepeat = true;
                  this.isloading = false;
                } else {
                  this.addApplicationPayroll2();
                }
              } else {
                this.addApplicationPayroll2();
              }
            })
            // } else {
            //   this.showBatch = true;
            // }
          }
        })
      },
      addApplicationPayroll2() {
        this.isloading = true;
        this.showRepeat = false;
        xz.addApplicationPayroll(this.formData, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.isloading = false;
            if (res.data.LegalSubjectCheckList != undefined && res.data.LegalSubjectCheckList.length > 0) {
              this.LegalSubjectCheckList = res.data.LegalSubjectCheckList;
              this.showLegError = true;
            } else {
              if (res.data.CardIdCheckList != undefined && res.data.FormatCheckList != undefined) {
                if (res.data.CardIdCheckList.length > 0 || res.data.FormatCheckList.length > 0) {
                  this.CardIdCheckList = res.data.CardIdCheckList;
                  this.FormatCheckList = res.data.FormatCheckList;
                  this.showError = true;
                }
              }
              if (res.data.ckecklist != undefined) {
                if (res.data.ckecklist != null && res.data.ckecklist != {}) {
                  if (res.data.ckecklist.ret1List != undefined) {
                    this.ret1List = res.data.ckecklist.ret1List
                  }
                  if (res.data.ckecklist.ret2List != undefined) {
                    this.ret2List = res.data.ckecklist.ret2List
                  }
                }
              }

              if (res.data.IssuedThisMonthList != undefined) {
                this.IssuedThisMonthList = res.data.IssuedThisMonthList;
              }
              if (res.data.BankAccountCheckList != undefined) {
                this.BankAccountCheckList = res.data.BankAccountCheckList;
              }
              if (res.data.getprojectLogList != undefined) {
                this.getprojectLogList = res.data.getprojectLogList;
              }
              if (this.IssuedThisMonthList.length == 0 && this.ret1List.length == 0 && this.ret1List.length == 0 && this.FormatCheckList.length == 0 && this.CardIdCheckList.length == 0 && this.BankAccountCheckList == 0 && this.getprojectLogList.length == 0) {
                this.active = 2;
                this.Warehousing();
              } else {
                this.active++;
              }
            }
          } else {
            this.isloading = false;
            this.$message.error(res.msg)
          }
        })
      },
      phoneHandel(num) {
        if (!this.both) {
          if (num != 5) {
            this.formData['IsConfirm'] = num;
            this.Warehousing();
            this.showPhoneError = false;
            this.showPhoneError2 = false;
          } else {
            this.showPhoneError2 = false;
          }
        } else {
          if (num == 0 || num == 1) {
            this.phoneHandelNum = num;
            this.showPhoneError = false;
            this.showPhoneError2 = true;
          } else if (num == 2) {
            if (this.phoneHandelNum == 1) {
              this.formData['IsConfirm'] = 4;
            } else {
              this.formData['IsConfirm'] = 3;
            }
            this.Warehousing();
            this.showPhoneError = false;
            this.showPhoneError2 = false;
          } else if (num == 5) {
            this.showPhoneError = false;
            this.showPhoneError2 = false;
          }
        }
      },
      taxSysHandel() {
        this.formData['IsEnter'] = 1;
        this.Warehousing();
        this.showPhoneError3 = false;
      },
      closeErrorTip() {
        // this.$router.go(-1);
        this.active = 0;
        this.showError = false;
      },
      //第二步 入库
      Warehousing() {
        this.formData.ckeck = '2';
        this.isloading = true;
        this.errPhoneList = [];
        xz.addApplicationPayroll(this.formData, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (this.formData.ApplySalary.PersonalIncomeTaxDataSource == '税局计算' || this.formData.ApplySalary.PayType == '预支工资') {
              this.getApplicationPayrollDetail(res.data, 'getAllTax');
            } else {
              this.getApplicationPayrollDetail(res.data, '');
            }
            localStorage.setItem("salaryId", res.data);
            this.active = 2;
            this.isloading = false;
          } else {
            if (res.data != null && res.data.Data != undefined) {
              if (res.data.Data == 0) {
                this.both = false;
                this.errPhoneList = res.data.Result;
                this.showPhoneError = true; //本次导入手机号和历史发薪手机号不符合
              } else if (res.data.Data == 1) {
                this.both = false;
                this.errPhoneList = res.data.Result;
                this.showPhoneError2 = true; //本次导入使用手机号和已被其他员工占用
              } else if (res.data.Data == 2) {
                this.both = true; //两个都弹窗
                this.errPhoneList = res.data.Result;
                this.showPhoneError = true;
              } else if (res.data.Data == 3) {
                this.both = false;
                this.errPhoneList = res.data.Result;
                this.showPhoneError3 = true;
              }
            } else {
              this.$message.error(res.msg)
            }
            this.isloading = false;
          }
        })
      },
      //第三步 获取详情
      getApplicationPayrollDetail(id, type) {
        if (id && id != '3') {
          this.listQuery.id = id;
        }
        this.listQuery.PersonnelCheck = this.activeName2 == '6' ? '' : this.activeName2;
        this.isloading = true;
        xz.getApplicationPayrollDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.baseInfo = res.data.data;
            this.ApplySalaryExt = res.data.ApplySalaryExt;
            this.dtlData = res.data.ApproveringList;
            this.totalcount = res.data.totalcount;
            // this.SummaryPersonnelDetails = res.data.SummaryPersonnelDetails;
            this.isOver = true;
            // this.dtlData.forEach(element => {
            //   this.getBearCostSocialSecurity(element)
            // });
            if (res.data.data.AnnualOneTimeBonus) {
              this.AnnualOneTimeBonus2 = true;
            }
            if (type == 'reCalc') {
              this.taxState = res.data.taxState;
              this.reCalc();
              if (res.data.checkState != '校验完成' && res.data.checkState != '终止校验' && res.data.checkState != '未校验') {
                this.showAllSign = true;
                this.isSigning = true;
                this.getAllStatus();
                this.intervalNum = 0;
                this.interval = setInterval(this.Refresh2, 10000)
              } else if (res.data.taxState && res.data.taxState != '算税完成' && res.data.taxState != '终止算税' && res.data.taxState != '未算税') {
                this.getAllStatus();
                this.showAllTax = true;
                this.isTaxing = true;
                this.intervalNum = 0;
                this.interval = setInterval(this.Refresh2, 10000)
              }
            } else {
              this.isloading = false;
            }
            if (id == '3') {
              this.$message.success('刷新成功')
            }
            if (type == 'getAllTax') {
              this.taxCalc();
              // if (this.formData.ApplySalary.PersonalIncomeTaxDataSource == '税局计算') {
              // this.allTaxSigning('');
              // setTimeout(() => {
              //   this.getAllTax('');
              // }, 500);
              // }
            }
            if (this.baseInfo.CustomerOriginalTableRul) {
              try {
                this.fileList2 = JSON.parse(this.baseInfo.CustomerOriginalTableRul)
              } catch (e) {
                this.fileList2 = [];
              }
            }
            // if (res.data.data.AssociatedClaim) {
            //   let expandQuery = {
            //     ids: res.data.data.AssociatedClaim
            //   }
            //   xz.getClaimRecordList(expandQuery, this.roletype).then(res => {
            //     if (res.status == 'ok') {
            //       this.PaymentData = res.data.data;
            //     } else {
            //       this.PaymentData = [];
            //     }
            //   })
            // }
          } else {
            this.$message.error('获取详情出错')
            this.isloading = false;
            this.totalcount = 0;
            this.baseInfo = {};
            this.dtlData = []
          }
        })
      },
      taxCalc() {
        this.showAllSign = true;
        this.isSigning = true;
        this.listQuery.busiType = '1';
        console.log('taxCalc')
        let data = {
          issend: "true",
          entname: this.baseInfo.Subject,
          datestr: this.baseInfo.IncomeTaxMonth,
          // datestr: '2024-01',
          userid: Cookies.get("userid-b"),
          id: this.dtlData[0].ParentId
        }
        xz.senduseralltoxft(data).then(res => {
          // if (res.status == 'ok') {
          //   clearInterval(this.interval);
          //   this.getAllStatus('');
          //   setTimeout(() => {
          //     this.getAllStatus('');
          //   }, 3000);
          //   this.intervalNum = 0;
          //   this.interval = setInterval(this.Refresh2, 10000)
          // } else {
          //   this.showAllSign = false;
          //   this.isSigning = false;
          //   this.$message.error(res.msg)
          // }
        })
        clearInterval(this.interval);
        this.getAllStatus('');
        setTimeout(() => {
          this.getAllStatus('');
        }, 3000);
        this.intervalNum = 0;
        this.interval = setInterval(this.Refresh2, 10000)
      },
      //启动算税计时：1000人以下3分钟、1000人以上5分钟到点关闭弹窗
      startTaxTimer() {
        this.clearTaxTimer();
        const count = Number(this.totalcount) || 0;
        const limit = count >= 1000 ? 5 * 60 : 3 * 60;
        this.taxElapsed = 0;
        this.taxTimer = setInterval(() => {
          this.taxElapsed++;
          if (this.taxElapsed >= limit) {
            clearInterval(this.interval);
            this.clearTaxTimer();
            this.isTaxing = false;
            this.showAllTax = false;
            this.taxLoading = false;
            this.$message.warning('算税超时，已自动关闭弹窗，请刷新页面查看算税结果')
          }
        }, 1000);
      },
      //清除算税计时器
      clearTaxTimer() {
        if (this.taxTimer) {
          clearInterval(this.taxTimer);
          this.taxTimer = null;
        }
        this.taxElapsed = 0;
      },
      //获取所有状态值
      getAllStatus() {
        xz.getApplicationPayrollDetailN1(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            // this.baseInfo = res.data.data;
            // this.dtlData = res.data.ApproveringList;
            this.taxState = res.data.taxState;
            this.checkSuccess = res.data.checkSuccess;
            this.checkFail = res.data.checkFail;
            this.taxSuccess = res.data.taxSuccess;
            this.taxFail = res.data.taxFail;
            this.taxNo = res.data.taxNo;
            if (this.showAllSign && res.data.checkState == '校验完成' && res.data.checkState != '终止校验') {
              this.getApplicationPayrollDetail(this.listQuery.id, '');
              this.isSigning = false;
              clearInterval(this.interval);
            } else if (this.showAllTax && res.data.taxState == '算税完成') {
              this.getApplicationPayrollDetail(this.listQuery.id, '');
              this.isTaxing = false;
              this.clearTaxTimer();
              clearInterval(this.interval);
            }
          }
        }).catch(() => {
          // 轮询请求失败时不中断后续轮询，由 setInterval 继续重试
        })
      },
      //刷新状态
      Refresh2() {
        this.intervalNum++;
        this.listQuery.intervalNum = this.intervalNum;
        this.getAllStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 240) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.clearTaxTimer();
          this.showAllSign = false;
          this.showAllTax = false;
          this.$message.warning('查询超时！')
        }
      },
      //继续算税
      continueGetTax() {
        this.taxLoading = true;
        this.listQuery.busiType = '2';
        let data0 = {
          projectName: this.baseInfo.ProjectName,
          incomeTaxMonth: this.baseInfo.IncomeTaxMonth
        }
        xz.CheckTaxState(data0).then(res => {
          if (res.status == 'ok') {
            if (res.taxState) {
              this.taxLoading = false;
              this.$message.warning('本项目有正在算税中批次，请等算税批次算税完成后再算税')
            } else {
              this.listQuery.ids = '';
              let data2 = {
                userid: Cookies.get("userid-b"),
                entname: this.baseInfo.Subject,
                objectid: this.baseInfo.ProjectId,
                datestr: this.baseInfo.IncomeTaxMonth,
                cacucode: this.baseInfo.Cacucode,
                id: this.dtlData[0].ParentId
              }
              this.hasGetTax = true;
              xz.senduserlisttax(data2).then(res => {
                if (res.status == 'ok') {
                  this.showAllSign = false;
                  this.taxLoading = false;
                  this.isTaxing = true;
                  this.showAllTax = true;
                  clearInterval(this.interval);
                  // this.getAllStatus('');
                  setTimeout(() => {
                    this.getAllStatus('');
                  }, 20000);
                  this.intervalNum = 0;
                  this.interval = setInterval(this.Refresh2, 10000);
                  this.startTaxTimer();
                } else {
                  this.showAllTax = false;
                  this.isTaxing = false;
                  this.$message.error(res.msg)
                }
              }).catch(() => {
                // 请求失败（如网络异常）时重置弹窗状态，避免算税弹窗卡在"算税中"无法关闭
                this.taxLoading = false;
                this.isTaxing = false;
                this.showAllTax = false;
                this.$message.error('算税请求失败，请重试')
              })

            }
          }
        }).catch(() => {
          this.taxLoading = false;
        })
      },
      reCalc() {
        let data = {
          ApplySalary: this.baseInfo,
          ckeck: "1", //1预览 /2入库
          userList: this.dtlData
        }
        xz.addApplicationPayroll(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.isloading = false;
            // this.incNum = 0;
            // this.active++;
            if (res.data.CardIdCheckList != undefined && res.data.FormatCheckList != undefined) {
              if (res.data.CardIdCheckList.length > 0 || res.data.FormatCheckList.length > 0) {
                this.CardIdCheckList = res.data.CardIdCheckList;
                this.FormatCheckList = res.data.FormatCheckList;
                this.showError = true;
              }
            }
            if (res.data.ckecklist != undefined) {
              if (res.data.ckecklist != null && res.data.ckecklist != {}) {
                if (res.data.ckecklist.ret1List != undefined) {
                  this.ret1List = res.data.ckecklist.ret1List
                  // console.log(this.ret1List)
                }
                if (res.data.ckecklist.ret2List != undefined) {
                  this.ret2List = res.data.ckecklist.ret2List
                }
              }
            }

            if (res.data.IssuedThisMonthList != undefined) {
              this.IssuedThisMonthList = res.data.IssuedThisMonthList;
              // console.log(this.IssuedThisMonthList)
            }
            if (res.data.BankAccountCheckList != undefined) {
              this.BankAccountCheckList = res.data.BankAccountCheckList;
            }
            if (this.IssuedThisMonthList.length == 0 && this.ret1List.length == 0 && this.ret1List.length == 0 && this.FormatCheckList.length == 0 && this.CardIdCheckList.length == 0 && this.BankAccountCheckList.length == 0) {
              // this.getApplicationPayrollDetail(res.data, '');
              this.active = 2;
            }
          } else {
            this.isloading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //获取原始数据
      DailyInspectionWarrantyLapse() {
        xz.getApplicationPayrollDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            // this.baseInfo = res.data.data;
            this.dtlData = res.data.InitList;
            this.totalcount = res.data.InitCount;
            this.isOver = true;
            this.isloading = false;
          } else {
            this.$message.error('获取详情出错')
            this.isloading = false;
            this.totalcount = 0;
            // this.baseInfo = {};
            this.dtlData = []
          }
        })
      },
      //查看客户到款信息
      getPayMore() {
        if (!this.showPayMore) {
          this.showPayMore = true;
          this.$nextTick(() => {
            this.multipleSelection.forEach(row => {
              this.$refs.multipleTable.toggleRowSelection(this.PaymentData.find(item => {
                return row.r.Id == item.r.Id;
              }), true)
            })
          })
        } else {
          this.showPayMore = false;
        }
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      handleSelectionChange2(val) {
        this.multipleSelection2 = val;
      },
      //人员信息查看
      readInfo(row) {
        this.info = row;
        console.log(this.info)
        this.showRead = true;
      },
      //人员信息修改
      editInfo(row, index) {
        this.info = row;
        this.index = index;
        this.showEdit = true;
      },
      cancel() {
        if (this.$route.query.Id != undefined && this.$route.query.Id) {
          this.$router.go(-1);
        } else {
          window.opener.location.reload();
          window.close()
        }
      },
      confirmEdit() {
        this.dtlData[this.index] = this.info;
        this.showEdit = false;
        this.saveLineData(this.dtlData[this.index]);
      },
      //下载
      down(url, head) {
        var path = head + url;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      //下载
      down2(url, head, name) {
        var path = head + url;
        const aTag = document.createElement('a')
        aTag.download = name //这里写保存时的名称
        aTag.href = path
        aTag.click();
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]' ||
          o == {}
        );
      },
      getPaymentInfo() {
        if (this.formData.ApplySalary.ProjectId && this.formData.ApplySalary.AttrMonth) {
          if (!this.showPaymentInfo) {
            let data = {
              ProjectIdStr: this.formData.ApplySalary.ProjectId,
              VestingMonth: this.formData.ApplySalary.AttrMonth
            }
            xz.getClaimRecordList(data, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.PaymentData = res.data.data;
                this.showPaymentInfo = true;
              } else {
                this.PaymentData = [];
              }
            })
          } else {
            this.showPaymentInfo = false;
          }
        } else {
          this.$message.warning('请先选择发薪项目和归属月')
        }
      },
      //保存发薪
      confirmSubmit() {
        this.btnLoading = true;
        // let userList = [];
        // this.dtlData.forEach(element => {
        //   userList.push(element)
        // });
        // if (this.AnnualOneTimeBonus2) {
        //   this.baseInfo.AnnualOneTimeBonus = '本年度还有一次性奖金发放';
        // }
        let data = {
          ApplySalary: this.baseInfo,
          userList: []
        }
        xz.updataApplicationPayroll(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            localStorage.setItem("salaryId", '');
            this.$message.success('保存成功！');
            this.cancel();
            this.btnLoading = false;
          } else {
            this.$message.error(res.msg);
            this.btnLoading = false;
          }
        })
      },
      beforeSubmit() {
        if (this.baseInfo.PersonalIncomeTaxDataSource == '税局计算') {
          this.btnLoading = true;
          this.checkQuery = {
            Id: this.listQuery.id,
            pageNum: 1,
            pageSize: 10
          }
          xz.getUnsuccessfulTaxList(this.checkQuery, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (res.data.Cacltotalcount > 0) {
                this.$message.warning('还有' + res.data.Cacltotalcount + '人正在计算个税，不能提交保存')
                this.btnLoading = false;
              } else if (res.data.totalcount > 0) {
                this.taxCheckUrl = res.data.content;
                this.taxCheckList = res.data.data;
                this.showTaxCheck = true;
                this.btnLoading = false;
              } else {
                this.confirmSubmit2();
              }
            } else {
              this.btnLoading = false;
              this.$message.error(res.msg)
            }
          })
        } else {
          this.confirmSubmit2();
        }
      },
      confirmSubmit2() {
        let data = {
          Id: this.listQuery.id,
          Ids: this.ids
        }
        xz.draftBecomesSalary(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.btnLoading = false;
            localStorage.setItem("salaryId", '');
            this.$message.success('保存成功！');
            // this.taxCalc();
            if (this.$route.query.Id != undefined && this.$route.query.Id) {
              this.$router.go(-1);
            } else {
              window.close()
            }
          } else {
            this.btnLoading = false;
            this.$message.error('系统出错')
          }
        })
      },
      taxReg() {
        if (this.multipleSelection2.length > 0) {
          this.showTaxCheck = true;
        } else {
          this.$message.warning('请至少选择一位员工');
        }
      },
      confirmTaxCheck() {
        this.showTaxCheck = false;
        this.showAllSign = true;
        this.isSigning = true;
        let id = '';
        let arr = [];
        this.multipleSelection2.forEach((element, index) => {
          arr.push(element.Id)
          if (index + 1 == this.multipleSelection2.length) {
            id = arr.toString();
          }
        });
        let data = {
          issend: "true",
          entname: this.baseInfo.Subject,
          datestr: this.baseInfo.IncomeTaxMonth,
          userid: Cookies.get("userid-b"),
          parmjsonstr: this.multipleSelection2
        }
        this.listQuery.ids = id;
        this.listQuery.busiType = '1';
        xz.sendusertoxft(data).then(res => {
          if (res.status == 'ok') {
            clearInterval(this.interval);
            this.getAllStatus('');
            setTimeout(() => {
              this.getAllStatus('');
            }, 3000);
            this.intervalNum = 0;
            this.interval = setInterval(this.Refresh2, 10000)
          } else {
            this.isloading = false;
            this.$message.error('税局校验出错');
            this.showTaxCheck = false;
          }
        })
      },
      //获取个税
      getTax() {
        if (this.multipleSelection2.length > 0) {
          // if (this.hasGetTax && this.isNull(this.baseInfo.Cacucode)) {
          //   this.$message.warning('正在获取个税，请稍后再试')
          // } else {
          //   clearInterval(this.interval);
          //   this.showTaxGet = true;
          // }
          clearInterval(this.interval);
          this.showTaxGet = true;
        } else {
          this.$message.warning('请至少选择一位员工');
        }
      },
      confirmTaxGet() {
        this.taxLoading = true;
        let data0 = {
          projectName: this.baseInfo.ProjectName,
          incomeTaxMonth: this.baseInfo.IncomeTaxMonth
        }
        xz.CheckTaxState(data0).then(res => {
          if (res.status == 'ok') {
            if (res.taxState) {
              this.taxLoading = false;
              this.$message.warning('本项目有正在算税中批次，请等算税批次算税完成后再算税')
            } else {
              this.showTaxGet = false;
              this.isTaxing = true;
              this.showAllTax = true;
              let id = '';
              let arr = [];
              this.multipleSelection2.forEach((element, index) => {
                arr.push(element.Id)
                if (index + 1 == this.multipleSelection2.length) {
                  id = arr.toString();
                }
              });
              let data = {
                userid: Cookies.get("userid-b"),
                entname: this.baseInfo.Subject,
                objectid: this.baseInfo.ProjectId,
                datestr: this.baseInfo.IncomeTaxMonth,
                cacucode: this.baseInfo.Cacucode,
                // inctype: this.baseInfo.IncomeTaxType == '正常工资薪金' ? '01' : this.baseInfo.IncomeTaxType == '全年一次性奖金' ? '02' : this.baseInfo.IncomeTaxType == '劳务报酬' ? '04' : '05',
                parmjsonstr: {
                  userList: id
                }
              }
              this.listQuery.ids = id;
              this.hasGetTax = true;
              xz.sendusertax(data, this.roletype).then(res => {
                if (res.status == 'ok') {} else {
                  // this.$message.error('系统出错');
                  // this.showTaxGet = false;
                }
              })
              clearInterval(this.interval);
              this.getAllStatus('');
              setTimeout(() => {
                this.getAllStatus('');
              }, 3000);
              this.intervalNum = 0;
              this.interval = setInterval(this.Refresh2, 10000);
            }
          }
        })
      },
      //刷新数据 
      Refresh() {
        this.intervalNum++;
        this.getApplicationPayrollDetail('', '');
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 3) {
          this.intervalNum = 0;
          clearInterval(this.interval);
        }
      },
      //获取整批个税
      getAllTax(type) {
        if (this.hasGetTax && this.isNull(this.baseInfo.Cacucode)) {
          this.$message.warning('正在获取个税，请稍后再试')
        } else {
          let data = {
            userid: Cookies.get("userid-b"),
            entname: this.baseInfo.Subject,
            objectid: this.baseInfo.ProjectId,
            datestr: this.baseInfo.IncomeTaxMonth,
            cacucode: this.baseInfo.Cacucode,
            inctype: this.baseInfo.IncomeTaxType == '正常工资薪金' ? '01' : this.baseInfo.IncomeTaxType == '全年一次性奖金' ? '02' : this.baseInfo.IncomeTaxType == '劳务报酬' ? '04' : '05',
            id: this.dtlData[0].ParentId
          }
          this.hasGetTax = true;
          xz.senduserlisttax(data).then(res => {
            if (type == '1') {
              if (res.status == 'ok') {
                this.$message.success('整批个税获取可能会有延迟，请等待数据刷新或者点击手动刷新按钮');
                clearInterval(this.interval);
                this.getApplicationPayrollDetail('', '');
                setTimeout(() => {
                  this.getApplicationPayrollDetail('', '');
                }, 3000);
                this.intervalNum = 0;
                this.interval = setInterval(this.Refresh, 10000)
              } else {
                this.$message.error(res.msg)
              }
            }

          })
        }

      },
      //整批税局登记
      allTaxSigning() {
        this.showAllSign = true;
        this.isSigning = true;
        this.listQuery.ids = '';
        let data = {
          issend: "true",
          entname: this.baseInfo.Subject,
          datestr: this.baseInfo.IncomeTaxMonth,
          // datestr: '2024-01',
          userid: Cookies.get("userid-b"),
          id: this.dtlData[0].ParentId
        }
        xz.senduseralltoxft(data).then(res => {
          if (res.status == 'ok') {
            clearInterval(this.interval);
            this.getAllStatus('');
            setTimeout(() => {
              this.getAllStatus('');
            }, 3000);
            this.intervalNum = 0;
            this.interval = setInterval(this.Refresh2, 10000)
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      //获取 本月实发  = 包含电话费补贴的税前应发 - 扣除了所有费用的应扣合计 + 其他调整
      getIssuedThisMonth(row) {
        let num = this.getNumRem(row.IncludesTelephoneSubsidy) - this.getNumRem(row.TotalDeductible) + this.getNumRem(row.OtherAdjustments)
        this.$set(row, 'IssuedThisMonth', Math.round(num * 100) / 100)
        this.saveLineData(row);
      },
      //获取 扣除了所有费用的应扣合计 = 税后扣款合计 + 小数点差额调整（默认为正数）
      getTotalDeductible(row) {
        let num = this.getNumRem(row.TotalAfterTaxDeductions) + this.getNumRem(row.DecimalPointBalance);
        this.$set(row, 'TotalDeductible', Math.round(num * 100) / 100);
        this.getIssuedThisMonth(row);
      },
      //获取 税后扣款合计 = 个人承担社保费用 + 个人承担公积金费用 +个人所得税 + 工会费 + 扣餐费 + 企业扣房租水电 + 公司扣房租水电 + 其他扣款（税后）+ 预支工资
      getTotalAfterTaxDeductions(row) {
        let num = this.getNumRem(row.BearCostSocialSecurity) + this.getNumRem(row.ProvidentFundCosts) + this.getNumRem(row.IndividualIncomeTax) + this.getNumRem(row.AbourUnionFees) + this.getNumRem(row.DeductMealFee) + this.getNumRem(row.CompanyDeductRentUtilities) + this.getNumRem(row.CompanyDeductsUtilities) + this.getNumRem(row.OtherDeductions) + this.getNumRem(row.AdvanceWages)
        this.$set(row, 'TotalAfterTaxDeductions', Math.round(num * 100) / 100);
        this.getTotalDeductible(row);
      },
      //获取 个人承担社保费用 = 个人承担养老 + 个人承担医疗 + 个人承担失业 
      getBearCostSocialSecurity(row) {
        let num = this.getNumRem(row.PersonalSupport) + this.getNumRem(row.PersonalCare) + this.getNumRem(row.PersonalUnemployment);
        this.$set(row, 'BearCostSocialSecurity', Math.round(num * 100) / 100);
        this.getTotalAfterTaxDeductions(row);
      },
      getNumRem(num) {
        // console.log(num)
        if (this.isNull(num)) {
          return 0
        } else {
          return Number(num)
        }
      },
      saveLineData(row) {
        let userList = [];
        userList.push(row)
        if (this.AnnualOneTimeBonus2) {
          this.baseInfo.AnnualOneTimeBonus = '本年度还有一次性奖金发放';
        }
        let data = {
          ApplySalary: this.baseInfo,
          userList: userList
        }
        xz.updataApplicationPayroll(data, this.roletype).then(res => {
          if (res.status == 'ok') {} else {
            this.$message.error(res.msg)
          }
        })
      },
      // getSummaries(param) {
      //   console.log('666',param)
      //   return NaN
      // },
      downTaxCheck() {
        let url = this.taxCheckUrl;
        let base64 = url.toString()
        let byteCharacters = atob(
          base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
        )
        let byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        let byteArray = new Uint8Array(byteNumbers)
        let blob = new Blob([byteArray], {
          type: `application/excel`
        })
        let aLink = document.createElement("a")
        aLink.download = '个税计算未成功名单.xls' //这里写保存时的图片名称
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
      },
      handleUploadPSR(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.ApplySalary.PayScaleRUL = res;
            this.fileListPSR.push({
              name: file.name,
              url: res,
            });
          } else {
            this.formData.DetailsUrl = ''
          }
        });
      },
      handleRemove1() {
        this.formData.PayScaleRUL = '';
        this.fileListPSR = [];
      },
      handleExceed1() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      //上传导入薪资表
      handleUploadCOT(file, fileList) {
        console.log(file)
        if (file.size > 10 * 1024 * 1024) {
          this.fileList = [];
          this.$message({
            type: 'warning',
            message: '上传的文件超过10M,请打包压缩后上传',
            duration: 5000
          })
        } else {
          const formData = new FormData();
          formData.append("pagename", "docinf");
          formData.append("action", "save");
          formData.append("userid", Cookies.get("userid-b"));
          formData.append("entid", Cookies.get("userid-b"));
          formData.append("excel", file.raw, file.name);
          console.log("formData", formData);
          xz.uploadCert(formData).then((res) => {
            if (res) {
              this.fileList.push({
                name: file.name,
                url: res,
              });
            } else {
              this.formData.DetailsUrl = ''
            }
          });
        }
      },
      handleRemove(file) {
        this.formData.DetailsUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 9 个文件`);
      },
      changePayrollChannel(val) {
        if (val == '灵活用工' || val == '安心云') {
          if (this.formData.ApplySalary.PersonalIncomeTaxDataSource == '税局计算') {
            this.formData.ApplySalary.PersonalIncomeTaxDataSource = '按导入数据';
            this.$message.warning(val + '不支持 税局计算，已自动替换为 按导入数据')
          }
        }
      },
      del(row) {
        if (this.dtlData.length > 1) {
          xz.delSsnDetail(row.Id).then((res) => {
            if (res.status == 'ok') {
              this.$message.success('删除成功');
              this.getApplicationPayrollDetail('', '');
              if (row.TaxBureauResults) {
                this.continueGetTax()
              }
            } else {
              this.$message.error(res.msg);
              this.getApplicationPayrollDetail('', '');
            }
          });
        } else {
          this.$message.warning('只剩一个人时，不能删除，请前往 “算薪” 页面作废该批次')
        }
      },
      searchHandle() {
        this.getApplicationPayrollDetail('', '');
      },
      setNewTemp() {
        const routerUrl = this.$router.resolve({
          path: "/setNewSalaryTemp",
          query: {
            ProjectName: this.formData.ApplySalary.ProjectName,
            ProjectId: this.formData.ApplySalary.ProjectId
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      //编辑模板
      editTemp() {
        const routerUrl = this.$router.resolve({
          path: "/setNewSalaryTemp",
          query: {
            Id: this.tempData.Id
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      //删除模板
      delTemp() {
        xz.delImportTemp(this.tempData.Id, this.roletype).then((res) => {
          if (res.status == 'ok') {
            this.$message.success('删除成功');
            this.getTempList();
          } else {
            this.$message.error(res.msg);
            this.getTempList();
          }
        });
      },
      changeTemp(val) {
        console.log(val)
        this.formData.ApplySalary.ImportTempId = val.Id;
        this.formData.ApplySalary.ImportTempName = val.TempName;
      },
      //停止校验
      StopCheck() {
        this.isloading = true;
        xz.StopCheck(this.baseInfo.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('终止成功')
            this.isloading = false;
            clearInterval(this.interval);
            this.showAllSign = false;
          } else {
            this.isloading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //停止算税
      StopTax() {
        this.isloading = true;
        xz.StopTax(this.baseInfo.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('终止成功')
            this.isloading = false;
            clearInterval(this.interval);
            this.clearTaxTimer();
            this.showAllTax = false;
          } else {
            this.isloading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //导出明细
      exportDtl() {
        let data = {
          Ids: this.baseInfo.Id,
          Type: '2',
          taxState: this.listQuery.taxState
        }
        this.isExpLoading = true;
        xz.payrollApplicationExport(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.baseInfo.ProjectName + this.baseInfo.IncomeTaxMonth + '明细列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExpLoading = false;
          } else {
            this.isExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //导出算税明细
      exportTaxDtl() {
        this.isTaxExpLoading = true;
        xz.exportTaxCalcuResultDetail(this.baseInfo.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.baseInfo.ProjectName + this.baseInfo.IncomeTaxMonth + '算税明细列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isTaxExpLoading = false;
          } else {
            this.isTaxExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //零收入补录
      zeroRecording(row) {
        this.info = row;
        this.zeroForm.IncomeTaxMonth = '';
        this.showZeroRecording = true;
      },
      confirmZeroRecording() {
        if (this.zeroForm.IncomeTaxMonth) {
          let data = {
            id: this.info.Id,
            IncomeTaxMonth: this.zeroForm.IncomeTaxMonth
          }
          this.zeroLoading = true;
          xz.ZeroRepair(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.zeroId = res.data.Id;
              this.zeroCacucode = res.data.Cacucode;
              this.zeroLoading = false;
              this.$message.success('保存成功');
              this.checkZero();
              // this.getApplicationPayrollDetail('', '');
              this.showZeroRecording = false;
            } else {
              this.zeroLoading = false;
              this.$message.error(res.msg);
              this.showZeroRecording = false;
            }
          })
        } else {
          this.$message.warning('请选择申报月')
        }
      },
      checkZero() {
        this.showZeroSign = true;
        this.isZeroSigning = true;
        let data = {
          issend: "true",
          entname: this.baseInfo.Subject,
          datestr: this.baseInfo.IncomeTaxMonth,
          userid: Cookies.get("userid-b"),
          id: this.zeroId
        }
        xz.senduseralltoxft(data).then(res => {
          // if (res.status == 'ok') {
          //   clearInterval(this.interval);
          //   this.getZeroStatus('');
          //   setTimeout(() => {
          //     this.getZeroStatus('');
          //   }, 3000);
          //   this.intervalNum = 0;
          //   this.interval = setInterval(this.RefreshZero, 10000)
          // } else {
          //   this.showZeroSign = false;
          //   this.isZeroSigning = false;
          //   this.$message.error(res.msg)
          // }
        })
        clearInterval(this.interval);
        this.getZeroStatus('');
        setTimeout(() => {
          this.getZeroStatus('');
        }, 3000);
        this.intervalNum = 0;
        this.interval = setInterval(this.RefreshZero, 10000)
      },
      getZeroTax() {
        this.showZeroSign = false;
        this.isZeroSigning = false;
        let data = {
          userid: Cookies.get("userid-b"),
          entname: this.baseInfo.Subject,
          objectid: this.baseInfo.ProjectId,
          datestr: this.zeroForm.IncomeTaxMonth,
          cacucode: this.baseInfo.zeroCacucode,
          id: this.zeroId
        }
        xz.senduserlisttax(data).then(res => {})
        clearInterval(this.interval);
        this.showZeroTax = true;
        this.isZeroTaxing = true;
        this.getZeroStatus();
        setTimeout(() => {
          this.getZeroStatus();
        }, 3000);
        this.intervalNum = 0;
        this.interval = setInterval(this.RefreshZero, 10000);
      },
      getZeroStatus() {
        let data = {
          id: this.zeroId
        }
        xz.ZeroRepairTax(data).then(res => {
          if (res.status == 'ok') {
            if (this.showAllSign && res.data.checkState == '校验完成' && res.data.checkState != '终止校验') {
              this.zeroCheckSuccess = res.data.checkSuccess;
              this.zeroCheckFail = res.data.checkFail;
              this.isZeroSigning = false;
              clearInterval(this.interval);
            } else if (this.showZeroTax && res.taxState == '算税完成') {
              this.zeroTaxSuccess = res.taxSuccess;
              this.zeroTaxFail = res.taxFail;
              this.zeroTaxNo = res.taxNo;
              this.isZeroTaxing = false;
              clearInterval(this.interval);
            }
          }
        })
      },
      RefreshZero() {
        this.intervalNum++;
        this.getZeroStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 240) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showZeroTax = false;
          this.$message.warning('查询超时！')
        }
      },
      toZeroList() {
        this.$router.push({
          path: '/zeroRepairList',
          query: {
            id: this.listQuery.id
          }
        })
      },
      getTruePay(row) {
        try {
          if (row.AdvanceWages && row.IndividualIncomeTax) {
            let d = row.AdvanceWages - row.IndividualIncomeTax;
            this.$set(row, 'IssuedThisMonth', d)
          }
        } catch {}
      },
      changeChannel(val) {
        if (val == '报销款（不报税）') {
          this.showBSTips = true;
        }
      },
      noBS() {
        this.formData.ApplySalary.PayrollChannel = '';
        this.showBSTips = false;
      },
      noLW() {
        this.formData.ApplySalary.IncomeTaxType = '';
        this.showLWtips = false;
      },
      FillSystemDataAdvanceWages() {
        let data = {
          id: this.listQuery.id,
          userid: Cookies.get("userid-b"),
          roletype: this.roletype
        }
        xz.BatchFillSystemDataAdvanceWages(data).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功');
            this.getApplicationPayrollDetail('3', '');
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      batchDetain() {
        if (this.multipleSelection2.length > 0) {
          let arr = [];
          this.multipleSelection2.forEach(element => {
            arr.push(element.Id)
          });
          let d = {
            id: arr.toString()
          }
          xz.ArdCurStat(d, 'SpTempWithhold').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.$message.success('操作成功');
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      changeSpecifyBankAccount(val) {
        if (val && this.bankList.length == 0) {
          let data = {
            name: '1',
          }
          xz.GetNotIsCbsAndIsSalary(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.bankList = res.data;
            } else {
              this.bankList = [];
            }
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .tempBtnBox {
    margin-left: 20px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  #fileInput2 {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 300px;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense2 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .salaryInfo {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .salaryInfoTitle {
    width: 110px;
    text-align: right;
    margin-right: 30px;
  }

  .salaryInfoItem {
    margin-right: 30px;
  }

  .selectCustomPayment {
    font-weight: 600;
    margin-bottom: 10px;
  }

  .abnormalTitle {
    margin: 10px 0;
    font-size: 16px;
    font-weight: 600;
  }

  .errNum {
    color: #F56C6C;
    margin: 0 7px;
  }

  .abnItem {
    padding-left: 20px;
  }

  .steps {
    width: 900px;
    padding: 30px 0 20px;
  }

  .btnBox {
    padding: 20px 0 50px 0;
    width: 900px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .showPaymentInfo {
    width: 1161px;
  }

  .infoBox {
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    display: flex;
    margin-right: 30px;
    flex-wrap: nowrap;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 170px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .readInfoItem1 {
    width: 270px;
    margin-right: 10px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .itemTitle {
    white-space: nowrap;
  }

  .itemContent {
    // overflow-wrap: anywhere;
    margin-left: 5px;
  }

  .down {
    color: #409EFF;
    margin-right: 15px;
  }

  .importBox {
    border: 1px solid #3333;
    padding: 10px 0;
    background: #E8F7F7;
  }

  .errNumTips {
    margin-bottom: 10px;
  }

  .lastInfo {
    color: #000;
    font-size: 14px;
  }

  .lastBox {
    font-size: 14px;
  }

  .PayTypeCheck {
    width: 300px
  }

  .taxCheckTitle {
    font-size: 18px;
  }

  .showMore {
    width: 1088px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    border: 1px solid #ebebeb;
    border-top: 1px solid #eaeefb;
    margin-bottom: 20px;
    font-size: 14px;
    // animation: slideDown 1s ease forwards;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .calcTips {
    font-size: 14px;
    color: red;
    line-height: 40px;
    margin-left: 30px;
  }

  .num1 {
    font-weight: 600;
    font-size: 14px;
  }

  .red {
    color: red;
  }

  .success {
    color: #19BD92;
  }

  .Checking {
    display: flex;
    justify-content: center;
  }

  .CheckingTips {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }

  .tips {
    color: red;
    margin-left: 83px;
    margin-bottom: 15px;
  }

  .loongTxt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 11em;
  }

  .zybz {
    margin-left: 490px;
  }

  .msgBox {
    max-height: 400px;
    overflow-y: auto;
    border-top: 1px solid #EBEEF5;
    margin-top: 10px;
  }

  .msgItem {
    text-align: center;
    padding: 8px 0;
    font-size: 13px;
    color: #606266;
    border-bottom: 1px solid #EBEEF5;
  }


  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .salaryForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_salary .salaryForm .el-form-item__error {
    top: 34px;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  /* .page_salary .salaryForm .el-icon-question:before {
    color: #F56C6C;
  }

  .page_salary .salaryForm .bankset .el-icon-question:before {
    color: #4B87E0;
  } */

  .abnormalTitle .el-icon-warning:before {
    color: rgb(255, 153, 0);
  }

  .page_salary .el-step__head.is-process {
    color: #FFCC33;
    border-color: #FFCC33;
  }

  .page_addCalcSalary .el-step.is-horizontal .el-step__line {
    top: 23px
  }

  .page_addCalcSalary .el-step__icon {
    font-size: 25px;
    width: 48px;
    height: 48px;
  }

  .page_addCalcSalary .dialogBox .el-dialog__body {
    padding-top: 0px;
  }

  .PayTypeCheck .el-checkbox__label {
    font-size: 12px;
    padding-left: 0;
  }

  .PersonalTaxIsBorne .el-checkbox__label {
    font-size: 12px;
    padding-left: 0;
  }

  .page_addCalcSalary .is-process .el-step__icon.is-text {
    background: #FFCC33;
  }

  .page_addCalcSalary .is-process .el-step__icon-inner {
    color: #fff;
  }

  .page_addCalcSalary .is-success .el-step__icon.is-text {
    background: #67C23A;
  }

  .page_addCalcSalary .is-success .el-step__icon-inner {
    color: #fff;
  }

  .page_addCalcSalary .demandForm .el-form-item__label {
    color: #999;
  }

  .page_addCalcSalary .demandForm .el-form--inline .el-form-item {
    width: 270px;
    margin-right: 0;
  }

  .page_addCalcSalary .demandForm .el-form-item {
    margin-bottom: 0;
  }

  /* .page_addCalcSalary .calcTableBox .el-table__footer-wrapper {
  position: absolute;
  top: 48px;
  left: 0;
}

.page_addCalcSalary .calcTableBox .el-table__body-wrapper {
  margin-top: 48px;
} */
  .page_addCalcSalary .el-table__fixed {
    height: calc(100% - 15px) !important;
  }

  .page_addCalcSalary .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .loongItem .el-form-item {
    width: 100% !important;
  }

  .loongItem .el-form-item__content {
    width: calc(100% - 200px)
  }
</style>